// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:06:26.642Z
// Property: James River Pointe (ID: 6767906449166324)
// Collections: 25 amenities, 9 floorplans (live), 50 photos, 77 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166324",
  "property_external_id": "30908",
  "property_zillow_url": "https://www.zillow.com/apartments/richmond-va/james-river-pointe/5XxdCN/",
  "property_apartments_url": "https://www.apartments.com/james-river-pointe-richmond-va/lqwpn7e/",
  "property_google_business_url": "https://www.google.com/maps/place/James+River+Pointe+Townhomes/data=!4m2!3m1!1s0x0:0xe255ec526601b89f?sa=X&ved=2ahUKEwjSwrrDsLiSAxV0kIkEHXqgD2UQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "james-river-pointe",
  "property_name": "James River Pointe",
  "property_website_url": "https://www.jamesriverpointe.com/",
  "property_domain": "https://www.jamesriverpointe.com/",
  "property_address": "435 German School Road",
  "property_full_address": "435 German School Rd, Richmond, VA 23225",
  "property_address_1": "435 German School Rd",
  "property_address_2": null,
  "property_address_city": "Richmond",
  "property_address_state": "VA",
  "property_address_zip_full": "23225-5939",
  "property_address_zip": "23225",
  "property_address_country": "US",
  "property_address_county": "Richmond City",
  "property_neighborhood_address": "Westover",
  "property_address_latitude": "37.5102719",
  "property_address_longitude": "-77.50353489999999",
  "property_email": "JamesRiverPointe@aionmanagement.com",
  "property_phone": "(804) 231-6598",
  "property_call_tracking_phone": "877-680-1317",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to James River Pointe in Richmond, VA, where comfort meets convenience. Choose from stylish one-, two-, or three-bedroom apartments featuring luxurious amenities like a swimming pool, dog park, and grilling stations. Experience community living with a bilingual team, flexible rent options, and a vibrant atmosphere. Start your new chapter today!",
  "property_long_description": "**Welcome to James River Pointe - Your Ideal Richmond Retreat!**\n\nDiscover the perfect blend of comfort and convenience at James River Pointe, an exceptional apartment community nestled in the heart of Richmond, VA. Our thoughtfully designed floor plans cater to every lifestyle with options that include stylish one-bedroom, spacious two-bedroom, and family-friendly three-bedroom apartments. With a variety of layouts to choose from, you’re sure to find the perfect home to suit your needs.\n\nAt James River Pointe, we prioritize your lifestyle with a wide array of amenities. Our bilingual property team is committed to providing excellent customer service, while our online resident portal and flex rent payment options offer added convenience. Your furry friends are welcome here too; our pet-friendly environment includes a dedicated dog park!\n\nDive into relaxation at our sparkling swimming pool or enjoy BBQ nights at our grilling stations. Children will love playing at the playground, and our picnic areas are perfect for weekend gatherings. With on-site management, 24-hour emergency maintenance, and available short-term leases, you can rest assured that all your needs will be met.\n\nConnectivity is a breeze with high-speed internet and easy access to public transportation nearby. Additional amenities include on-site parking, air conditioning, wall-to-wall carpeting, and in-unit washers and dryers, ensuring a well-rounded living experience.\n\nDon’t miss the opportunity to call James River Pointe home! Browse our availability today or schedule a tour to explore our vibrant community tailored just for you. Find your new home today at James River Pointe!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-819a-7358-b369-6f5085c75ff0.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
    "public_id": "019fcdff-819a-7358-b369-6f5085c75ff0",
    "storage_key": "property/6767906449166324/019fcdff-819a-7358-b369-6f5085c75ff0.webp",
    "width": 1920,
    "height": 1282
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "538",
  "property_year_built": "1966",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.88475836431226",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $1000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum of 2 pets per townhome, each up to 100 lb. Certain breeds (e.g., German Shepherds, Akitas, Chow mixes, American Bulldogs, Staffordshire Terriers, Dobermans, Rottweilers, wolf hybrids, Pit Bulls, Presa Canarios, and mixes ≥50%) are prohibited.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum of 2 pets per townhome, each up to 100 lb. AION allows dogs, cats, and service animals; all must be housebroken. Certain breeds (e.g., German Shepherds, Akitas, Chow mixes, American Bulldogs, Staffordshire Terriers, Dobermans, Rottweilers, wolf hybrids, Pit Bulls, Presa Canarios, and mixes ≥50%) are prohibited. A non‑refundable pet fee of $350 and monthly pet rent of $50 per pet apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://jamesriverpointe.loftliving.com/login",
  "property_apply_now_url": "https://www.jamesriverpointe.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0266-f8c5-75dc-a876-fffd87fa74e1.webp",
  "property_primary_logo_media": {
    "alt_text": "James River Pointe logo with a stylized JR above the text.",
    "public_id": "019d0266-f8c5-75dc-a876-fffd87fa74e1",
    "storage_key": "property/6767906449166324/019d0266-f8c5-75dc-a876-fffd87fa74e1.webp",
    "width": 1294,
    "height": 563
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0266-f8c5-75dc-a876-fffd87fa74e1.webp",
  "property_secondary_logo_media": {
    "alt_text": "James River Pointe logo with a stylized JR above the text.",
    "public_id": "019d0266-f8c5-75dc-a876-fffd87fa74e1",
    "storage_key": "property/6767906449166324/019d0266-f8c5-75dc-a876-fffd87fa74e1.webp",
    "width": 1294,
    "height": 563
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0269-d705-7071-bdaa-515803af7e43.webp",
  "property_icon_media": {
    "alt_text": "JR logo",
    "public_id": "019d0269-d705-7071-bdaa-515803af7e43",
    "storage_key": "property/6767906449166324/019d0269-d705-7071-bdaa-515803af7e43.webp",
    "width": 256,
    "height": 255
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0269-d705-7071-bdaa-515803af7e43.webp",
  "property_fav_icon_media": {
    "alt_text": "JR logo",
    "public_id": "019d0269-d705-7071-bdaa-515803af7e43",
    "storage_key": "property/6767906449166324/019d0269-d705-7071-bdaa-515803af7e43.webp",
    "width": 256,
    "height": 255
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0266-f8c5-75dc-a876-f89537957f00.webp",
  "property_mono_white_logo_media": {
    "alt_text": "James River Pointe logo",
    "public_id": "019d0266-f8c5-75dc-a876-f89537957f00",
    "storage_key": "property/6767906449166324/019d0266-f8c5-75dc-a876-f89537957f00.webp",
    "width": 640,
    "height": 278
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0269-ef57-72dc-9166-c021261aa089.webp",
  "property_mono_black_logo_media": {
    "alt_text": "James River Pointe logo",
    "public_id": "019d0269-ef57-72dc-9166-c021261aa089",
    "storage_key": "property/6767906449166324/019d0269-ef57-72dc-9166-c021261aa089.webp",
    "width": 640,
    "height": 278
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "680 - 1232",
  "property_sqft_min": "680",
  "property_sqft_max": "1232",
  "property_price_range": "1803",
  "property_price_min": null,
  "property_price_max": "1803",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/jamesriverpointe/",
  "property_instagram_url": "https://www.instagram.com/jamesriverpointe/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJWZVxSlsSsYkRn7gBZlLsVeI",
  "property_youtube_url": "https://www.youtube.com/watch?t=421&v=VeW4C9BoDGU",
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Real+Estate&find_loc=Beaufont%2C+Richmond%2C+VA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to James River Pointe",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "Welcome to James River Pointe in Richmond, VA, where comfort meets convenience! Choose from stylish one, two, or three-bedroom apartments, complete with essential amenities like high-speed internet and a pet-friendly atmosphere. Enjoy sun-soaked afternoons by the pool, cozy picnics, or playful moments in the dog park—your perfect home awaits!",
  "property_home_floorplans_blurb": "Welcome to James River Pointe in Richmond, VA, where comfort meets style! Choose from our thoughtfully designed one, two, or three-bedroom apartments. Each layout offers unique features to complement your lifestyle. Browse our available apartment homes and find the perfect floor plan that feels just right for you!",
  "property_home_gallery_blurb": "At James River Pointe in Richmond, VA, your perfect home awaits! With one-, two-, and three-bedroom layouts, our community offers a vibrant lifestyle complemented by pet-friendly amenities, a swimming pool, and a welcoming bilingual team. Picture yourself enjoying life here—where comfort meets convenience!",
  "property_home_neighborhood_blurb": "Welcome to James River Pointe, where spacious one, two, and three-bedroom apartments harmonize with vibrant Richmond living. Nestled near cultural gems like the Virginia Museum of Fine Arts and the enchanting Lewis Ginter Botanical Garden, your new home invites you to embrace a life rich with arts, nature, and adventure!",
  "property_home_reviews_blurb": "At James River Pointe in Richmond, VA, residents are thriving in a community that feels like home. With a dedicated team led by Cassandra and Marquita, guest experiences shine through: “The property is great! A lot of work has been done by the new team.” Discover why our residents rave about their living experience!",
  "property_neighborhood_blurb": "Nestled in the vibrant heart of Richmond, James River Pointe offers easy access to cultural gems like the Virginia Museum of Fine Arts and the serene beauty of Lewis Ginter Botanical Garden. Enjoy the nearby recreational spots, including Forest Hill Park and James River Park, as you embrace a community filled with excitement.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At James River Pointe in Richmond, VA, comfort meets convenience. Choose from one, two, or three-bedroom apartments featuring modern amenities like a pet-friendly environment, grilling stations, and a refreshing swimming pool. Our bilingual team is here to ensure your living experience is exceptional and worry-free. Your perfect home awaits!",
  "property_applynow_blurb": "At James River Pointe in Richmond, VA, vibrant living awaits you! Choose from stylish one, two, and three-bedroom floor plans, complete with pet-friendly amenities, a sparkling swimming pool, and a welcoming dog park. Join our community today and enjoy seamless online leasing—your perfect home is just a click away!",
  "property_contactus_blurb": "At James River Pointe in Richmond, VA, our diverse floor plans—one, two, and three-bedroom apartments—cater to your unique lifestyle. Enjoy spacious living and modern amenities with stunning river views. Curious about available options? Reach out to our leasing team today and elevate your living experience!",
  "property_faqs_blurb": "At James River Pointe in Richmond, VA, our diverse floor plans cater to every lifestyle, from cozy one-bedroom retreats to spacious three-bedroom homes. For any queries about our vibrant community, check out our FAQs page for insights and helpful answers tailored just for you!",
  "property_floorplans_blurb": "At James River Pointe in Richmond, VA, your ideal living space awaits! Choose from thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Embrace comfort and style while browsing our available apartment homes to find the perfect fit for you. Your new adventure starts today!",
  "property_gallery_blurb": "At James River Pointe in Richmond, VA, vibrant living comes alive through diverse floor plans—one, two, and three-bedroom options perfect for any lifestyle. Picture weekend BBQs at our grilling stations, fun at the playground, or lounging by the pool. Imagine your new home, where comfort meets convenience!",
  "property_interactivemap_blurb": "At James River Pointe in Richmond, VA, your perfect home awaits across diverse floor plans—one, two, and three bedrooms, plus townhomes. Enjoy an array of amenities, from a refreshing swimming pool to a welcoming dog park. Use our interactive community map to find your ideal apartment today!",
  "property_pets_blurb": "At James River Pointe in Richmond, VA, your furry friends are more than welcome! With room for two pets per townhome, your beloved cats and dogs can enjoy a spacious and vibrant community. Experience pet-friendly living, complete with scenic walking paths and ample green spaces right at your doorstep!",
  "property_referafriend_blurb": "At James River Pointe in Richmond, VA, your perfect home awaits—be it a cozy one-bedroom or a spacious three-bedroom. Invite your friends to share the exceptional lifestyle and beautiful surroundings. Great friends make great neighbors—refer a friend to our community today and enrich your living experience together!",
  "property_residentaccess_blurb": "Welcome to James River Pointe in vibrant Richmond, VA, where comfort meets convenience. Our diverse floor plans—one, two, and three-bedroom options—cater to every lifestyle. Stay connected and make life easier by accessing your resident portal to pay rent, schedule maintenance, and explore community updates. Your new home awaits!",
  "property_reviews_blurb": "At James River Pointe in Richmond, VA, our residents rave about the exceptional care and support they receive from our dedicated team. One happy resident notes, “Cassandra and Marquita have really turned the property around!” Experience community living where every detail is attended to for your comfort.",
  "property_created_at": "1757006365569",
  "property_scheduletour_blurb": "At James River Pointe in Richmond, VA, find your ideal space among our thoughtfully designed one, two, and three-bedroom floor plans. Each home boasts modern comfort and style. Curious about our vibrant community? Schedule a tour and see what our residents love most about living here!",
  "property_thankyou_blurb": "Thank you for reaching out to James River Pointe! Nestled in the heart of Richmond, VA, our stylish one, two, and three-bedroom floor plans cater to your lifestyle. A team member will connect with you soon to help you find your perfect home in our vibrant community.",
  "property_virtualtours_blurb": "Experience the charm of James River Pointe in Richmond, VA, where our thoughtfully designed one, two, and three-bedroom apartments blend comfort with style. Each floor plan offers unique features to suit your lifestyle. Don’t just imagine living here—take a virtual tour and see your future home today!",
  "property_copyright": "2025 All Rights Reserved. James River Pointe",
  "property_seo_title_home": "James River Pointe | Townhomes in Richmond, VA",
  "property_seo_description_home": "Discover James River Pointe townhomes in Richmond, VA. Enjoy spacious floor plans, pet-friendly amenities, and convenient community features,",
  "property_seo_title_floorplans": "Floor Plans | Richmond, VA Townhomes for Rent",
  "property_seo_description_floorplans": "Find your ideal space at James River Pointe in Richmond, VA. Choose from stylish one, two, or three-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Richmond, VA Townhomes for Rent",
  "property_seo_description_amenities": "Explore amenities at James River Pointe townhomes in Richmond, VA, including a pool, pet-friendly features, online payments, and more. Schedule a tour today!",
  "property_seo_title_gallery": "Gallery | James River Pointe Townhomes in Richmond, VA",
  "property_seo_description_gallery": "Imagine life at James River Pointe in Richmond, VA! Enjoy spacious floor plans, a pet-friendly atmosphere, and vibrant amenities. View our gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | James River Pointe Townhomes Richmond",
  "property_seo_description_virtualtours": "Explore James River Pointe townhomes in Richmond, VA with a virtual tour. View spacious one, two, and three-bedroom floor plans from wherever you are.",
  "property_seo_title_interactivemap": "Interactive Map | James River Pointe Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at James River Pointe, Richmond, VA! Explore our interactive map for pet-friendly apartments and exciting amenities.",
  "property_seo_title_neighborhood": "Neighborhood | James River Pointe Townhomes Richmond, VA",
  "property_seo_description_neighborhood": "Explore the neighborhood around James River Pointe townhomes in Richmond, VA. Discover nearby dining, shopping, parks, and local destinations",
  "property_seo_title_contact": "Contact Us | James River Pointe",
  "property_seo_description_contact": "Contact James River Pointe to learn more about our one to three-bedroom townhomes in Richmond, VA. Connect with our leasing team and schedule a tour today!",
  "property_seo_title_faqs": "FAQs | Apartments in Richmond, VA",
  "property_seo_description_faqs": "Got questions about James River Pointe in Richmond, VA? Our FAQs offer quick answers about floor plans, amenities, and community life—all tailored for you!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Richmond, VA",
  "property_seo_description_reviews": "Experience life at James River Pointe in Richmond, VA. From spacious floor plans to pet-friendly amenities, see why our residents cherish their home!",
  "property_seo_title_applynow": "Apply Now | Townhomes for Rent in Richmond, VA",
  "property_seo_description_applynow": "Find your next townhome at James River Pointe in Richmond, VA. Explore spacious layouts, pet-friendly amenities, a swimming pool, and more. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | James River Pointe",
  "property_seo_description_residentaccess": "Manage your life at James River Pointe! Log in to the resident portal for easy rent payment, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | James River Pointe",
  "property_seo_description_referafriend": "Refer a friend to James River Pointe in Richmond, VA! Great friends make the best neighbors—unlock the joy of community living together today!",
  "property_seo_title_scheduletour": "Schedule a Tour | James River Pointe Townhomes Richmond, VA",
  "property_seo_description_scheduletour": "Experience the charm of James River Pointe in Richmond, VA. Schedule your tour and envision your future in our vibrant community today!",
  "property_seo_title_privacy": "Privacy Policy | James River Pointe",
  "property_seo_description_privacy": "At James River Pointe, Richmond, VA, your privacy matters. Discover how we protect your information and ensure a secure living environment!",
  "property_seo_title_accessibility": "Website Accessibility | James River Pointe",
  "property_seo_description_accessibility": "At James River Pointe in Richmond, VA, we prioritize digital inclusion and accessibility for all. Experience a community where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | James River Pointe",
  "property_seo_description_sitemap": "Explore James River Pointe in Richmond, VA! Use our sitemap to find amenities, floor plans, and community features easily.",
  "property_seo_title_thankyou": "Thank You | James River Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to James River Pointe in Richmond, VA! Our team will connect soon to help you find your perfect home by the river.",
  "property_seo_title_pets": "Pet Policy | Apartments in Richmond, VA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293568984",
  "amenities": [
    {
      "id": "custom_3c422293-88d9-47ed-8dbc-886303d92cec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c60f065e-9523-4907-a3e7-784595d007fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c8b67c1-276f-44dc-aeb1-2458a718a3f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4746d87-3710-4a41-83a7-d4ff6fef1dc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eec03d1b-f28d-4819-9443-2a238472944d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases Available",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69b96d60-7903-4456-9043-2cddd0fd60d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Bilingual Site Team",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6a45efc-9cec-4736-b635-71726191c4ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c76ae78a-6b41-4d5c-be96-ae9bdb0edaee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "In-Home Washer and Dryer*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_617b5486-d704-43e9-b8ce-76e1261f4ecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_287a8b5e-12b7-4fd7-8af1-4793e9b41f74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Microwave",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d557669-5b5a-4285-96c5-333c1de7fa1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5730a064-36bc-4135-84d6-8ee85d25c8f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e2ab08d-22e7-4400-af6b-d8e64e7fc30b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Bathrooms",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54876bf8-7f15-4929-beb9-fb33ca9360e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens w/ Breakfast Bars*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95b3edd6-8f58-4b78-95b7-5d7bd3cbfab1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_072a7aee-1a7e-4111-b5da-da3506cb2845",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7669ea37-7665-4823-8191-116d6ef61826",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient to Stony Point Fashion Park and Chippenham Medical Center",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2c2e372d-247c-4352-ab75-254c3346c3c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "15 minutes to the West End and Midlothian",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4e070b97-2a5e-4e09-8734-e88a46b0ef35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "15 Minutes to Virginia Commonwealth University",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0cb0c1bd-93f6-4897-8b31-be2d658eafb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "6 Miles to Downtown Richmond",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31549c6d-48d1-4516-9934-c1cc51cb3344",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Free Resident Parking",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a9ff7d57-6b4a-4954-9613-4c6cbbed2c2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_131e9e60-6cc9-43c1-b3e1-d44d23bbe3b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_446ace45-6ebd-407a-a6b0-c4104daac4c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling and Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d335e19b-8a6b-492e-b25e-3e35e40c45ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_d2c7435f-227b-43fa-a50f-d998bcc07579",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-9287-766c-836c-97bd8d7cf18c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019fcdff-9287-766c-836c-97bd8d7cf18c",
        "storage_key": "property/6767906449166324/019fcdff-9287-766c-836c-97bd8d7cf18c.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, sleek black appliances including a refrigerator, oven, microwave, and dishwasher. Granite countertops and a tiled backsplash complete the look.",
      "link": "",
      "alt_text": "Kitchen with dark brown cabinets, black appliances, and a gray countertop at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/JRP_BR1A_0012_JRP_K1A_jxcuwo-271bbea5.jpg"
    },
    {
      "id": "custom_a13b5237-266b-4951-ba92-9b2005f0e812",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-927d-70e6-99d6-7cf05478961c.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and entryway door.",
        "public_id": "019fcdff-927d-70e6-99d6-7cf05478961c",
        "storage_key": "property/6767906449166324/019fcdff-927d-70e6-99d6-7cf05478961c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, a stylish coffee table, and a welcoming entryway. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with couch, coffee table, and console table. Door, window, and stairs visible at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/Web__0001_James_River_Point_2_LR1_06-09-23_07_46_lduef7-ba5ea46a.jpg"
    },
    {
      "id": "custom_396a7e7a-327f-4991-a1fd-6e0d6ec96fc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-9286-702f-bb3e-6d05b0fcc715.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, closet, and window.",
        "public_id": "019fcdff-9286-702f-bb3e-6d05b0fcc715",
        "storage_key": "property/6767906449166324/019fcdff-9286-702f-bb3e-6d05b0fcc715.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bedroom with bed, dresser, window, and closet. Neutral colors and natural light create a calm atmosphere at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Bedroom with bed, dresser, window, and closet. Neutral colors and natural light create a calm atmosphere at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/JRP_BR1A_0014_JRP_BR4A_msn7wt.jpg"
    },
    {
      "id": "custom_903ae4a6-1d9f-4534-a186-ecbc0b3e3e20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-9e5d-776b-ad37-8f719479a0f3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019fcdff-9e5d-776b-ad37-8f719479a0f3",
        "storage_key": "property/6767906449166324/019fcdff-9e5d-776b-ad37-8f719479a0f3.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Black appliances in a kitchen with dark cabinets, light countertops, and beige tiled floor at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Black appliances in a kitchen with dark cabinets, light countertops, and beige tiled floor at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/JRP_BR1A_0011_JRP_K1B_kk0ykq-b8b267c8.jpg"
    },
    {
      "id": "custom_1b537e4f-b9f8-4b7f-b55a-43ae4544b2df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-9f3d-741d-8afb-32dd0d8c5bc2.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, two windows with cream curtains, and a closet.",
        "public_id": "019fcdff-9f3d-741d-8afb-32dd0d8c5bc2",
        "storage_key": "property/6767906449166324/019fcdff-9f3d-741d-8afb-32dd0d8c5bc2.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bedroom with a bed, two windows with curtains, art on the wall, and a closed door at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Bedroom with a bed, two windows with curtains, art on the wall, and a closed door at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/JRP_BR1A_0016_JRP_BR3A_smgj9r.jpg"
    },
    {
      "id": "custom_b4d75ee3-041f-4ae4-b8c6-6b4d70e9bc2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-9fe4-7528-b1a9-09db8a2f3cdb.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, bed, and closet.",
        "public_id": "019fcdff-9fe4-7528-b1a9-09db8a2f3cdb",
        "storage_key": "property/6767906449166324/019fcdff-9fe4-7528-b1a9-09db8a2f3cdb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bedroom with dresser, bed, open window, and artwork on the wall at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Bedroom with dresser, bed, open window, and artwork on the wall at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/Web__0006_James_River_Point_2_BR3_28-08-23_10_35_rkuvrx-bd2cf8ac.jpg"
    },
    {
      "id": "custom_66051383-f324-4b2b-8629-7d18d6121210",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-9fea-7615-916f-dc0b15a50a36.webp",
      "image_media": {
        "alt_text": "Kitchenette with a small table and chairs, a refrigerator, and a stove.",
        "public_id": "019fcdff-9fea-7615-916f-dc0b15a50a36",
        "storage_key": "property/6767906449166324/019fcdff-9fea-7615-916f-dc0b15a50a36.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Kitchen with table, chairs, black appliances, window, and closed white doors. Gray walls and flooring at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Kitchen with table, chairs, black appliances, window, and closed white doors. Gray walls and flooring at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/JRP_BR1A_0010_JRP_K1C_olqpnb.jpg"
    },
    {
      "id": "custom_0a95d5b6-6512-431c-94a4-a30c75248c9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-ab50-71f4-a84b-35108d8c27d3.webp",
      "image_media": {
        "alt_text": "Kitchen area with counter seating and decorative console table.",
        "public_id": "019fcdff-ab50-71f4-a84b-35108d8c27d3",
        "storage_key": "property/6767906449166324/019fcdff-ab50-71f4-a84b-35108d8c27d3.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Kitchen with a bar, stools, and a table with candles. Artwork on the wall and a window with a blind at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Kitchen with a bar, stools, and a table with candles. Artwork on the wall and a window with a blind at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/JRP_BR1A_0013_JRP_Dining_Room_ued3fa.jpg"
    },
    {
      "id": "custom_5da7962d-22be-430e-b50d-d87681bc4e3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-ab4a-76a8-b255-9a6473d6cd15.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, dark wood floors, and a window.",
        "public_id": "019fcdff-ab4a-76a8-b255-9a6473d6cd15",
        "storage_key": "property/6767906449166324/019fcdff-ab4a-76a8-b255-9a6473d6cd15.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "white kitchen with refrigerator, stove, sink, and window over a dark wood floor at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "white kitchen with refrigerator, stove, sink, and window over a dark wood floor at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/JRP_BR1A_0006_JRP_K2D_dtlwc1.jpg"
    },
    {
      "id": "custom_33ceb6b0-24b4-4923-98be-39f807680a38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-acb7-733d-8dda-c16fac9f2cec.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee table, armchair, and TV.",
        "public_id": "019fcdff-acb7-733d-8dda-c16fac9f2cec",
        "storage_key": "property/6767906449166324/019fcdff-acb7-733d-8dda-c16fac9f2cec.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable couch, coffee table, armchair, and modern entertainment setup.",
      "link": "",
      "alt_text": "Bright modern living room with gray sofa, coffee table, armchair, and wall art at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/Web__0000_James_River_Point_2_LR2_06-09-23_07_40_rjbwuc-6934632c.jpg"
    },
    {
      "id": "custom_22f0e0ad-02fe-4423-9385-392501a9e69c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-b14e-7755-9bac-c6b3f6b0d736.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and a decorative wall art.",
        "public_id": "019fcdff-b14e-7755-9bac-c6b3f6b0d736",
        "storage_key": "property/6767906449166324/019fcdff-b14e-7755-9bac-c6b3f6b0d736.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bedroom with a bed, open closet, wall art, and soft neutral decor at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Bedroom with a bed, open closet, wall art, and soft neutral decor at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/JRP_BR1A_0015_JRP_BR3B_fvamae.jpg"
    },
    {
      "id": "custom_49735b1e-9a89-49e3-abc4-b7ff57c766dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-b644-725b-82fa-6e60063aecc8.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, accent art, and a large window.",
        "public_id": "019fcdff-b644-725b-82fa-6e60063aecc8",
        "storage_key": "property/6767906449166324/019fcdff-b644-725b-82fa-6e60063aecc8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Wake up in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, elegant accent art, and ample natural light from a large window.",
      "link": "",
      "alt_text": "Bright bedroom with white bed, gray bench, and window with curtains at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/Web__0011_James_River_Point_2_BR1_06-09-23_07_32_e3qhdt-262d180c.jpg"
    },
    {
      "id": "custom_76d1ee43-b922-42ca-b2ae-042aee37f2c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-b711-7618-9b22-ae5bd9bc5926.webp",
      "image_media": {
        "alt_text": "Stackable Frigidaire washer and dryer set with louvered doors",
        "public_id": "019fcdff-b711-7618-9b22-ae5bd9bc5926",
        "storage_key": "property/6767906449166324/019fcdff-b711-7618-9b22-ae5bd9bc5926.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Apartment",
      "description": "Stacked washer and dryer in a narrow laundry closet with white louvered doors at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Stacked washer and dryer in a narrow laundry closet with white louvered doors at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/James_River_Point.jpg"
    },
    {
      "id": "custom_4b0cbb3d-9a43-4a21-bce8-a456dbb94416",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-bb55-71ab-9e71-9a1371d5a748.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with white sink, chrome faucet, and mirrored medicine cabinet.",
        "public_id": "019fcdff-bb55-71ab-9e71-9a1371d5a748",
        "storage_key": "property/6767906449166324/019fcdff-bb55-71ab-9e71-9a1371d5a748.webp",
        "width": 1340,
        "height": 2007
      },
      "title": "Apartment",
      "description": "White bathroom vanity with sink, mirror, and light fixture on a light gray wall at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "White bathroom vanity with sink, mirror, and light fixture on a light gray wall at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/Web_00012_James_River_Pointe_BTH2_rmzqnc-fcc1b21d.jpg"
    },
    {
      "id": "custom_e96aa1be-30a2-468c-b29d-a59b35e3ecc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-bc20-7682-acc0-781b471e5766.webp",
      "image_media": {
        "alt_text": "Clean and modern bathroom with a white vanity, toilet, and bathtub with a grey shower curtain.",
        "public_id": "019fcdff-bc20-7682-acc0-781b471e5766",
        "storage_key": "property/6767906449166324/019fcdff-bc20-7682-acc0-781b471e5766.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright white bathroom with a sink, toilet, bathtub, mirror, and shower curtain at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Bright white bathroom with a sink, toilet, bathtub, mirror, and shower curtain at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/JRP_BR1A_0000_JRP_BTH2A_sfdpda.jpg"
    },
    {
      "id": "custom_fb935e55-2628-4c1a-91b8-9ee738099d89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c1d3-734f-9e2c-e0bc27a94425.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, toilet, and bathtub with shower.",
        "public_id": "019fcdff-c1d3-734f-9e2c-e0bc27a94425",
        "storage_key": "property/6767906449166324/019fcdff-c1d3-734f-9e2c-e0bc27a94425.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright white bathroom with sink, toilet, cabinet, and tub with shower curtain at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Bright white bathroom with sink, toilet, cabinet, and tub with shower curtain at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/Web__0008_James_River_Point_2_BTH1_28-08-23_11_08_ifozka-44b92cb9.jpg"
    },
    {
      "id": "custom_034ef96f-3b4c-468f-ac6f-4b34e591e41c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c5c1-713a-95b8-448282b919cd.webp",
      "image_media": {
        "alt_text": "Exterior view of brick townhomes with blooming pink flowers overhead.",
        "public_id": "019fcdff-c5c1-713a-95b8-448282b919cd",
        "storage_key": "property/6767906449166324/019fcdff-c5c1-713a-95b8-448282b919cd.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Row of brick apartment units with white doors and windows beside a grassy lawn under pink blossoms and a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Row of brick apartment units with white doors and windows beside a grassy lawn under pink blossoms and a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_6169_0007_DSC_6231_u3mzyb.jpg"
    },
    {
      "id": "custom_48066c8f-ca3a-42db-be84-c10ea92b0b8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c5e4-7328-949b-22af070d33f0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c5e4-7328-949b-22af070d33f0",
        "storage_key": "property/6767906449166324/019fcdff-c5e4-7328-949b-22af070d33f0.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Poolside resort patio with orange umbrella, lounge chairs, and turquoise swimming pool under a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Poolside resort patio with orange umbrella, lounge chairs, and turquoise swimming pool under a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_3825_0003_DSC_5929_ohiovq.jpg"
    },
    {
      "id": "custom_4ad4da34-e3e4-49e5-985f-69a886938e3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs, umbrellas, and apartment buildings on a sunny day at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_3825_0002_DSC_5936_gntzor.jpg"
    },
    {
      "id": "custom_ddc55432-4a7e-4732-bc63-47edbc2628aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-cc84-7531-a8a0-88e8b69726a0.webp",
      "image_media": {
        "alt_text": "Picnic tables and grills outside apartment buildings.",
        "public_id": "019fcdff-cc84-7531-a8a0-88e8b69726a0",
        "storage_key": "property/6767906449166324/019fcdff-cc84-7531-a8a0-88e8b69726a0.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor picnic tables on a concrete pad in front of brick apartment buildings and green lawn under a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Outdoor picnic tables on a concrete pad in front of brick apartment buildings and green lawn under a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_3825_0006_DSC_3921_fk5zss.jpg"
    },
    {
      "id": "custom_93643f2a-e3f3-41d8-a8fe-a275a6cbc4a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-d230-769a-9ece-c512c5babe7b.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with grills and tables, adjacent to a swimming pool and playground.",
        "public_id": "019fcdff-d230-769a-9ece-c512c5babe7b",
        "storage_key": "property/6767906449166324/019fcdff-d230-769a-9ece-c512c5babe7b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and recreation with our picnic areas, complete with grills and seating, near the sparkling swimming pool and fun-filled playground.",
      "link": "",
      "alt_text": "Park picnic area with a grill, benches, trash cans, and trees under a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_3825_0001_DSC_5947_jgubea.jpg"
    },
    {
      "id": "custom_54eebf4d-2b73-4903-90e9-0f50aa2d830e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-d662-749c-8155-e17e6eebbb46.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment and bone-shaped decorations.",
        "public_id": "019fcdff-d662-749c-8155-e17e6eebbb46",
        "storage_key": "property/6767906449166324/019fcdff-d662-749c-8155-e17e6eebbb46.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Grassy dog park between red brick houses, with small agility obstacles and black fencing at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Grassy dog park between red brick houses, with small agility obstacles and black fencing at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_3825_0007_DSC_3926_we6lke.jpg"
    },
    {
      "id": "custom_494125ec-4f63-44f1-95b2-3d36a296f770",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-d630-76d6-8c9d-724eb30694f7.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, tunnel, and ramp.",
        "public_id": "019fcdff-d630-76d6-8c9d-724eb30694f7",
        "storage_key": "property/6767906449166324/019fcdff-d630-76d6-8c9d-724eb30694f7.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with fun agility equipment for your furry friends.",
      "link": "",
      "alt_text": "Outdoor dog agility course with tunnel, ramp, and poles on a grassy field near buildings at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_3825_0008_DSC_3929_lhptod.jpg"
    },
    {
      "id": "custom_2eda2e1b-17b1-4045-964e-c6a474875cc5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-dace-754b-978b-d335f4871cac.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park area with agility equipment and benches.",
        "public_id": "019fcdff-dace-754b-978b-d335f4871cac",
        "storage_key": "property/6767906449166324/019fcdff-dace-754b-978b-d335f4871cac.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Small fenced grassy memorial field with signs, a flagpole, and a brick building under a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Small fenced grassy memorial field with signs, a flagpole, and a brick building under a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_6169_0001_DSC_6201_ylesx1.jpg"
    },
    {
      "id": "custom_82a5bfb9-773f-44aa-a733-ee4ddc08ff6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-df47-70de-b970-a2cab0b56538.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures",
        "public_id": "019fcdff-df47-70de-b970-a2cab0b56538",
        "storage_key": "property/6767906449166324/019fcdff-df47-70de-b970-a2cab0b56538.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Playground with green slide, climbing structure, and wood-chip ground in a park at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Playground with green slide, climbing structure, and wood-chip ground in a park at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_3825_0004_DSC_3834_oo86pm.jpg"
    },
    {
      "id": "custom_99a1bfab-b860-4020-88a6-b56ede696e85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-e21c-7764-bb7f-6ddf660623ec.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019fcdff-e21c-7764-bb7f-6ddf660623ec",
        "storage_key": "property/6767906449166324/019fcdff-e21c-7764-bb7f-6ddf660623ec.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Playground with green slides and climbing structures on a woodchip surface under a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Playground with green slides and climbing structures on a woodchip surface under a blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_6169_0009_DSC_6183_ydq3aj.jpg"
    },
    {
      "id": "custom_692dfef7-3fcf-4fc4-b256-a1f0cc3951ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-e316-76f8-a8d2-f1ca01146f1b.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with green lawns and trees.",
        "public_id": "019fcdff-e316-76f8-a8d2-f1ca01146f1b",
        "storage_key": "property/6767906449166324/019fcdff-e316-76f8-a8d2-f1ca01146f1b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Charming brick apartment buildings with welcoming entrances, surrounded by lush green lawns and mature trees, offering a pleasant community atmosphere.",
      "link": "",
      "alt_text": "Row of red brick townhouses with front steps and small porches along a grassy sidewalk under trees at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_3825_0009_DSC_3937_ch0dky.jpg"
    },
    {
      "id": "custom_effbaaca-5a94-44f9-82c4-6cca9ea5023e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-e71c-7683-8f84-cd0a0dca5fad.webp",
      "image_media": {
        "alt_text": "Exterior view of red brick townhouses with green lawns and blue sky.",
        "public_id": "019fcdff-e71c-7683-8f84-cd0a0dca5fad",
        "storage_key": "property/6767906449166324/019fcdff-e71c-7683-8f84-cd0a0dca5fad.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Two-story brick apartment building with a grassy lawn and curb in front at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Two-story brick apartment building with a grassy lawn and curb in front at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DSC_3825_0000_DSC_3908_n2la30.jpg"
    },
    {
      "id": "custom_7c3a661d-e963-458c-a224-3a6e0ca02e0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-eb59-770a-88eb-808fdac45bc0.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with well-maintained lawns and autumn foliage.",
        "public_id": "019fcdff-eb59-770a-88eb-808fdac45bc0",
        "storage_key": "property/6767906449166324/019fcdff-eb59-770a-88eb-808fdac45bc0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Brick apartment buildings with green lawns and autumn leaves under a bright blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Brick apartment buildings with green lawns and autumn leaves under a bright blue sky at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/Apartment_Exterior_uskkkw.jpg"
    },
    {
      "id": "custom_dca95493-e4bc-4bcd-908e-88ed58c1e6c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-ee5c-723d-b038-bcd39047ce48.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with swimming pool, lounge chairs, umbrellas, and playground.",
        "public_id": "019fcdff-ee5c-723d-b038-bcd39047ce48",
        "storage_key": "property/6767906449166324/019fcdff-ee5c-723d-b038-bcd39047ce48.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Aerial view of a resort pool with lounge chairs, orange umbrellas, and nearby cabins on a grassy property at James River Pointe Townhomes in Richmond, VA.",
      "link": "",
      "alt_text": "Aerial view of a resort pool with lounge chairs, orange umbrellas, and nearby cabins on a grassy property at James River Pointe Townhomes in Richmond, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/1095bbf3/dms3rep/multi/DJI_20230830112432_0154_D_0002_DJI_20230830111958_0129_D_fhoywl.jpg"
    },
    {
      "id": "custom_1e347fae-97b9-45ff-b5ad-9b160537f839",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a15999-9d98-72b9-bbbc-e9700b6ccc59.webp",
      "image_media": {
        "alt_text": "Living room with a green sofa, coffee table, and a view into the kitchen.",
        "public_id": "01a15999-9d98-72b9-bbbc-e9700b6ccc59",
        "storage_key": "property/6767906449166324/01a15999-9d98-72b9-bbbc-e9700b6ccc59.webp",
        "width": 3072,
        "height": 2029
      },
      "title": "Apartment",
      "description": "Spacious living area with a comfortable green sofa, modern coffee table, and a stylish kitchen featuring white cabinets and granite countertops. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a green sofa, coffee table, and a view into the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae1300ef-5ec1-43c0-b9c5-182a090136e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a15999-a63f-701f-bff0-b7dfa98ea633.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-size bed, nightstands, and lamps.",
        "public_id": "01a15999-a63f-701f-bff0-b7dfa98ea633",
        "storage_key": "property/6767906449166324/01a15999-a63f-701f-bff0-b7dfa98ea633.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully staged bedroom, featuring a plush queen-size bed, elegant nightstands, and modern lamps, creating a serene and inviting atmosphere.",
      "link": "",
      "alt_text": "A staged bedroom with a queen-size bed, nightstands, and lamps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43c475d2-0b64-4fc2-b076-39105405b9dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a15999-9b34-710f-afaa-62ce7b01bf09.webp",
      "image_media": {
        "alt_text": "Living room with a green sofa, coffee table, and door.",
        "public_id": "01a15999-9b34-710f-afaa-62ce7b01bf09",
        "storage_key": "property/6767906449166324/01a15999-9b34-710f-afaa-62ce7b01bf09.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable green sofa, a modern coffee table with decor, and neutral-toned walls. A door and windows add to the room's inviting atmosphere.",
      "link": "",
      "alt_text": "Living room with a green sofa, coffee table, and door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c20ba94c-caba-4f9c-8bf3-11b31ac5bab5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a15999-8a1e-74ac-a23c-0bfb102c19a3.webp",
      "image_media": {
        "alt_text": "A home office setup with a desk, chair, and plant in a neutral-toned room.",
        "public_id": "01a15999-8a1e-74ac-a23c-0bfb102c19a3",
        "storage_key": "property/6767906449166324/01a15999-8a1e-74ac-a23c-0bfb102c19a3.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this apartment's dedicated office nook, featuring a sleek desk, comfortable chair, and ample natural light from the window.",
      "link": "",
      "alt_text": "A home office setup with a desk, chair, and plant in a neutral-toned room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7a5c65c-3238-4ed6-bcb1-d4a62f1f6694",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a15999-87b2-776e-96b2-10122f092af8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dining nook featuring a glass-top table and two blue chairs, window, refrigerator, and oven.",
        "public_id": "01a15999-87b2-776e-96b2-10122f092af8",
        "storage_key": "property/6767906449166324/01a15999-87b2-776e-96b2-10122f092af8.webp",
        "width": 3072,
        "height": 2056
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen with a charming dining nook, perfect for casual meals. Features modern appliances, ample cabinet space, and a large window for natural light.",
      "link": "",
      "alt_text": "Modern kitchen with dining nook featuring a glass-top table and two blue chairs, window, refrigerator, and oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba9401bd-a1bd-4085-8363-e34707fe72ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a15999-7762-764f-86bc-6bccfa2d049f.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, black appliances, and a breakfast bar with stools.",
        "public_id": "01a15999-7762-764f-86bc-6bccfa2d049f",
        "storage_key": "property/6767906449166324/01a15999-7762-764f-86bc-6bccfa2d049f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen featuring ample cabinet space, modern black appliances, and a convenient breakfast bar with seating.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, black appliances, and a breakfast bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b126d02-3b2b-4859-9459-66091027415c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a15999-7518-75fc-b82e-d7f9ee513150.webp",
      "image_media": {
        "alt_text": "Living room with couch, TV, and window",
        "public_id": "01a15999-7518-75fc-b82e-d7f9ee513150",
        "storage_key": "property/6767906449166324/01a15999-7518-75fc-b82e-d7f9ee513150.webp",
        "width": 3072,
        "height": 1999
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable couch, entertainment center with a large TV, and ample natural light from the window.",
      "link": "",
      "alt_text": "Living room with couch, TV, and window",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_40a6c09d-77d4-4a0a-8472-57b48237ca88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a15999-835e-749c-afa7-51f9181d4d54.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, nightstand, lamp, and large window.",
        "public_id": "01a15999-835e-749c-afa7-51f9181d4d54",
        "storage_key": "property/6767906449166324/01a15999-835e-749c-afa7-51f9181d4d54.webp",
        "width": 3072,
        "height": 2058
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant nightstand with a lamp, and a large window for natural light.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, nightstand, lamp, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_df993415-e114-48ab-b5b8-ff4ca02a2bf7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a15999-7f16-772f-abe7-aa05bd60745a.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances and light wood cabinets.",
        "public_id": "01a15999-7f16-772f-abe7-aa05bd60745a",
        "storage_key": "property/6767906449166324/01a15999-7f16-772f-abe7-aa05bd60745a.webp",
        "width": 3072,
        "height": 1984
      },
      "title": "Apartment",
      "description": "Updated kitchen featuring black appliances, light wood cabinetry, and wood-look flooring.",
      "link": "",
      "alt_text": "Kitchen with black appliances and light wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8496a570-0730-4b18-a116-f2f4ce3d9a9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14211-626a-750e-95ca-76048c8468e6.webp",
      "image_media": {
        "alt_text": "Exterior of brick apartment buildings with well-maintained lawns and mature trees.",
        "public_id": "01a14211-626a-750e-95ca-76048c8468e6",
        "storage_key": "property/6767906449166324/01a14211-626a-750e-95ca-76048c8468e6.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Discover comfortable living in these charming brick apartment buildings, surrounded by lush greenery and mature trees. Enjoy the peaceful community atmosphere.",
      "link": "",
      "alt_text": "Exterior of brick apartment buildings with well-maintained lawns and mature trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_caf99f62-6700-45bb-aeb1-3c2bb10b8f8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14211-3c20-7138-9557-cb9ad7515f55.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with sink and mirror.",
        "public_id": "01a14211-3c20-7138-9557-cb9ad7515f55",
        "storage_key": "property/6767906449166324/01a14211-3c20-7138-9557-cb9ad7515f55.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Clean and bright bathroom featuring a bathtub, toilet, and a spacious vanity with a sink and mirror, perfect for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d1539204-e8f7-48e4-bca0-867d7bbe8b7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14211-36bc-76eb-bca8-8d084de3cec3.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer behind bi-fold doors in a closet.",
        "public_id": "01a14211-36bc-76eb-bca8-8d084de3cec3",
        "storage_key": "property/6767906449166324/01a14211-36bc-76eb-bca8-8d084de3cec3.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "In-unit stacked washer and dryer for convenient laundry access.",
      "link": "",
      "alt_text": "Stacked washer and dryer behind bi-fold doors in a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dd8779cd-5658-4f2b-b864-ebfb097e85da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14211-20f7-718c-ae0d-15c81165877d.webp",
      "image_media": {
        "alt_text": "Clean, white bathroom with a bathtub, toilet, and vanity.",
        "public_id": "01a14211-20f7-718c-ae0d-15c81165877d",
        "storage_key": "property/6767906449166324/01a14211-20f7-718c-ae0d-15c81165877d.webp",
        "width": 3072,
        "height": 2119
      },
      "title": "Apartment",
      "description": "Bright and airy bathroom featuring a pristine white bathtub, modern vanity, and a large window for natural light.",
      "link": "",
      "alt_text": "Clean, white bathroom with a bathtub, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a6f2ea1-7551-431e-b827-c1fff89be184",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14211-1068-7735-a9b0-8e8d7b5cf20c.webp",
      "image_media": {
        "alt_text": "James River Pointe apartment complex exterior with signage and landscaping.",
        "public_id": "01a14211-1068-7735-a9b0-8e8d7b5cf20c",
        "storage_key": "property/6767906449166324/01a14211-1068-7735-a9b0-8e8d7b5cf20c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to James River Pointe, a premier apartment community offering comfortable living and convenient amenities. Now leasing!",
      "link": "",
      "alt_text": "James River Pointe apartment complex exterior with signage and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16307254-0ada-4081-bca0-febf62e0d36c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14211-0c51-75ef-8550-a9279e1b4260.webp",
      "image_media": {
        "alt_text": "White kitchen with a gas stove, refrigerator, washer, and dryer.",
        "public_id": "01a14211-0c51-75ef-8550-a9279e1b4260",
        "storage_key": "property/6767906449166324/01a14211-0c51-75ef-8550-a9279e1b4260.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen featuring white cabinetry, a gas stove, refrigerator, and in-unit washer and dryer. Perfect for meal preparation and everyday convenience.",
      "link": "",
      "alt_text": "White kitchen with a gas stove, refrigerator, washer, and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_360e0218-7179-4734-8adb-c3d695d37da0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14211-0272-7309-877a-c0e4383fb8ff.webp",
      "image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and trees.",
        "public_id": "01a14211-0272-7309-877a-c0e4383fb8ff",
        "storage_key": "property/6767906449166324/01a14211-0272-7309-877a-c0e4383fb8ff.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Exterior view of brick apartment buildings featuring well-maintained lawns and lush green trees. Offers a glimpse into the property's welcoming facade.",
      "link": "",
      "alt_text": "Exterior of brick apartment buildings with green lawns and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8779d0b8-7085-4e23-a48e-56a6ea62b3a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14211-0199-70af-b1ce-cd05e1b87508.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with well-maintained lawn and blue sky.",
        "public_id": "01a14211-0199-70af-b1ce-cd05e1b87508",
        "storage_key": "property/6767906449166324/01a14211-0199-70af-b1ce-cd05e1b87508.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Charming brick apartment buildings set within a beautifully landscaped community, offering a comfortable and welcoming atmosphere.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with well-maintained lawn and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e3c5059-25eb-4ab0-960f-3ce4fb728af7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14210-e0fc-7319-abdb-1773f7b0d47e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black appliances, and a stacked washer/dryer unit.",
        "public_id": "01a14210-e0fc-7319-abdb-1773f7b0d47e",
        "storage_key": "property/6767906449166324/01a14210-e0fc-7319-abdb-1773f7b0d47e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Step into this well-appointed kitchen featuring sleek white cabinetry, durable granite countertops, and a full suite of black appliances, including an in-unit washer and dryer for ultimate convenience.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, black appliances, and a stacked washer/dryer unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08e9e72d-de8e-4494-a5e1-a9ed0ad391cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14210-c4e9-764d-9959-7ab1b0ba7116.webp",
      "image_media": {
        "alt_text": "Half bathroom with a pedestal sink and toilet.",
        "public_id": "01a14210-c4e9-764d-9959-7ab1b0ba7116",
        "storage_key": "property/6767906449166324/01a14210-c4e9-764d-9959-7ab1b0ba7116.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A stylish half bathroom featuring a modern pedestal sink and a clean white toilet, perfect for guests.",
      "link": "",
      "alt_text": "Half bathroom with a pedestal sink and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78598fc7-0640-4d05-bc5a-12ca967a0415",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a14210-bcf0-77da-b186-f0e46f8ce552.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances and white cabinets.",
        "public_id": "01a14210-bcf0-77da-b186-f0e46f8ce552",
        "storage_key": "property/6767906449166324/01a14210-bcf0-77da-b186-f0e46f8ce552.webp",
        "width": 3072,
        "height": 2066
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring black appliances including a refrigerator, stove, microwave, and dishwasher, complemented by white cabinetry and granite countertops.",
      "link": "",
      "alt_text": "Kitchen with black appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_becbf125-43fe-406d-bf9d-230e5e1f587a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Crossroads Coffee & Ice Cream",
      "poi_type": "Restaurants",
      "poi_address": "3600 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Funky breakfast-through-dinner cafe serving simple American fare, desserts & craft beer.",
      "poi_long_description": "Funky breakfast-through-dinner cafe serving simple American fare, desserts & craft beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-019c-754a-8e03-281bb34d5f7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-019c-754a-8e03-281bb34d5f7f",
        "storage_key": "property/6767906449166324/019fce00-019c-754a-8e03-281bb34d5f7f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://crossroadsrva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13125098004575370176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-coffee--ice-cream",
      "poi_latitude": "37.5154064",
      "poi_longitude": "-77.4714328",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-231-2030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe9-769b-a0a4-fc380f983512.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe9-769b-a0a4-fc380f983512",
        "storage_key": "property/6767906449166324/019d0268-1fe9-769b-a0a4-fc380f983512.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJLy2Q9CkSsYkRwDvnbBi3JbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_aa6498b6-ba12-447a-9d10-a18601c403ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Eat 66",
      "poi_type": "Restaurants",
      "poi_address": "2845 Hathaway Rd, Richmond, VA 23225, USA",
      "poi_short_description": "Breakfast place featuring catfish, chicken and waffles, pancakes and other Southern eats in a vibrant setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0159-766d-bbdc-50045399a043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-0159-766d-bbdc-50045399a043",
        "storage_key": "property/6767906449166324/019fce00-0159-766d-bbdc-50045399a043.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://eat66rva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4332513472117839853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eat-66",
      "poi_latitude": "37.5393479",
      "poi_longitude": "-77.51793780000001",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-716-6169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe6-71f1-b6c2-89884e6cbfa9",
        "storage_key": "property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0P5dv8TsYkR7ZctWgwuIDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d6b9a39b-c690-4a0a-935d-0fb1f94a67be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Natalie's",
      "poi_type": "Restaurants",
      "poi_address": "2825 Hathaway Rd, Richmond, VA 23225, USA",
      "poi_short_description": "Lebanese restaurant featuring classic kebabs and shawarma in a modern dining space, plus a patio.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0173-7658-91be-956fb4614a94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-0173-7658-91be-956fb4614a94",
        "storage_key": "property/6767906449166324/019fce00-0173-7658-91be-956fb4614a94.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://nataliesrva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15492035581927759174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "natalies",
      "poi_latitude": "37.5387083",
      "poi_longitude": "-77.5184556",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-499-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe6-71f1-b6c2-89884e6cbfa9",
        "storage_key": "property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2FJCb5qsYkRRh2EDEjE_tY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cd8c35e2-ad23-4d5d-a9a3-a8c83483347b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Galley",
      "poi_type": "Restaurants",
      "poi_address": "2805 Hathaway Rd, Richmond, VA 23225, USA",
      "poi_short_description": "Local eatery & bar with a quirky, casual vibe & a menu of sandwiches, pasta & all-day breakfast.",
      "poi_long_description": "Local eatery & bar with a quirky, casual vibe & a menu of sandwiches, pasta & all-day breakfast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-024b-7412-b85a-7ec872d78981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-024b-7412-b85a-7ec872d78981",
        "storage_key": "property/6767906449166324/019fce00-024b-7412-b85a-7ec872d78981.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.galleykitchen.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13207350681080821511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "galley",
      "poi_latitude": "37.5381666",
      "poi_longitude": "-77.51866969999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-323-1102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe6-71f1-b6c2-89884e6cbfa9",
        "storage_key": "property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqSbHVwgTsYkRB_fVCXjvSbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0e91f74a-6e45-4663-a4fb-b82a17587595",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Joe's Italian Grill and Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "6331 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "Easygoing Italian option in a shopping center offering classic pizzas & pastas, plus subs & salads.",
      "poi_long_description": "Easygoing Italian option in a shopping center offering classic pizzas & pastas, plus subs & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0775-759f-8222-4c319ddbae82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-0775-759f-8222-4c319ddbae82",
        "storage_key": "property/6767906449166324/019fce00-0775-759f-8222-4c319ddbae82.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.joesitaliangrilltogo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4428147892886029290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joes-italian-grill-and-pizzeria",
      "poi_latitude": "37.51947699999999",
      "poi_longitude": "-77.5131",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-303-3273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe6-71f1-b6c2-89884e6cbfa9",
        "storage_key": "property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD-pe1FUSsYkR6sNdGAzxcz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4e405dc3-d8ce-40ae-8510-b47dd175a435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "DaVinci Pizza",
      "poi_type": "Restaurants",
      "poi_address": "4610 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Casual eatery offering pizza, wings, and other comfort food, plus late-night hours.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0805-70cb-9307-783097880de0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-0805-70cb-9307-783097880de0",
        "storage_key": "property/6767906449166324/019fce00-0805-70cb-9307-783097880de0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.davincipizzarichmond.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=6624568470951427469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "davinci-pizza",
      "poi_latitude": "37.5202072",
      "poi_longitude": "-77.4857883",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-230-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe6-71f1-b6c2-89884e6cbfa9",
        "storage_key": "property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_twDDMSsYkRjf1PBe0x71s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_90394e4e-4a1c-4db7-bcea-33d829dd8a5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Maldini's Ristorante Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "4811 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Warm, familiar Italian bar & restaurant preparing brick-oven pizzas, sandwiches & classic mains.",
      "poi_long_description": "Warm, familiar Italian bar & restaurant preparing brick-oven pizzas, sandwiches & classic mains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-08d2-71fd-a1e9-5381fdf40bd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-08d2-71fd-a1e9-5381fdf40bd3",
        "storage_key": "property/6767906449166324/019fce00-08d2-71fd-a1e9-5381fdf40bd3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.maldinisrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17191062697411851170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maldinis-ristorante-pizzeria",
      "poi_latitude": "37.521186",
      "poi_longitude": "-77.487625",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-230-9055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe6-71f1-b6c2-89884e6cbfa9",
        "storage_key": "property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSeeRnjQSsYkRorOz7nDsku4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_27d94e46-bcd8-4546-86d7-3a3317ccceb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "O'Toole's Restaurant & Pub",
      "poi_type": "Restaurants",
      "poi_address": "4800 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Long-running Irish joint with brick walls & sports on TV provides bar food & pints.",
      "poi_long_description": "Long-running Irish joint with brick walls & sports on TV provides bar food & pints.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0941-7559-b4b6-c11289e3f0f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-0941-7559-b4b6-c11289e3f0f3",
        "storage_key": "property/6767906449166324/019fce00-0941-7559-b4b6-c11289e3f0f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://otoolesrestaurant.weebly.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16400632508791152551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "otooles-restaurant--pub",
      "poi_latitude": "37.520497",
      "poi_longitude": "-77.487465",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-233-1781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1feb-7319-85d3-81fc39f2fd4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1feb-7319-85d3-81fc39f2fd4f",
        "storage_key": "property/6767906449166324/019d0268-1feb-7319-85d3-81fc39f2fd4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1bx9gjQSsYkRp184Wl_AmuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dc388b38-8b1e-4978-ae32-dff8fd2687c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Mexico Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7001 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Vibrant cantina serving traditional fare from fajitas to carne asada, plus margaritas.",
      "poi_long_description": "Vibrant cantina serving traditional fare from fajitas to carne asada, plus margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0e0a-7398-a042-016d45fe8b33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-0e0a-7398-a042-016d45fe8b33",
        "storage_key": "property/6767906449166324/019fce00-0e0a-7398-a042-016d45fe8b33.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mexico-restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8251729959578753439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mexico-restaurant",
      "poi_latitude": "37.5373187",
      "poi_longitude": "-77.52443579999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-320-1069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe6-71f1-b6c2-89884e6cbfa9",
        "storage_key": "property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj5bfeQ8TsYkRn9kjv60IhHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bd203be9-6edf-4216-92c6-11a3227376b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Jason's Deli",
      "poi_type": "Restaurants",
      "poi_address": "7115 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Deli chain featuring specialty sandwiches, salads & other health-conscious fare.",
      "poi_long_description": "Deli chain featuring specialty sandwiches, salads & other health-conscious fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0eb0-74ef-9037-a1dee22ec0db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-0eb0-74ef-9037-a1dee22ec0db",
        "storage_key": "property/6767906449166324/019fce00-0eb0-74ef-9037-a1dee22ec0db.webp",
        "width": 1280,
        "height": 708
      },
      "poi_business_url": "https://www.jasonsdeli.com/locations/va/richmond/7115-forest-hill-ave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5230162820506656988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jasons-deli",
      "poi_latitude": "37.5355396",
      "poi_longitude": "-77.5261362",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-323-9390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe6-71f1-b6c2-89884e6cbfa9",
        "storage_key": "property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6V-Ijg8TsYkR3CDB6V9FlUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_45f93d99-cae7-4c43-8d7d-b239b3f8017c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "7107 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0f31-76ec-a922-e56cbfe081a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-0f31-76ec-a922-e56cbfe081a2",
        "storage_key": "property/6767906449166324/019fce00-0f31-76ec-a922-e56cbfe081a2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/14662",
      "poi_directions_map_url": "https://maps.google.com/?cid=8562966855520380898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "37.53494",
      "poi_longitude": "-77.52721",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-330-7365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe9-769b-a0a4-fc380f983512.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe9-769b-a0a4-fc380f983512",
        "storage_key": "property/6767906449166324/019d0268-1fe9-769b-a0a4-fc380f983512.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJA8gsKgUTsYkR4me8jvzE1XY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9bc83b6d-d118-4cd3-956c-f482f529dad9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Little Nickel",
      "poi_type": "Restaurants",
      "poi_address": "4702 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Stylish diner-style stop serving Philippine, Hawaiian, & Mediterranean fusion plus tropical drinks.",
      "poi_long_description": "Stylish diner-style stop serving Philippine, Hawaiian, & Mediterranean fusion plus tropical drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1021-72c9-bc89-233f7450c38b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-1021-72c9-bc89-233f7450c38b",
        "storage_key": "property/6767906449166324/019fce00-1021-72c9-bc89-233f7450c38b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://littlenickel.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907967727519365578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-nickel",
      "poi_latitude": "37.5202622",
      "poi_longitude": "-77.4864418",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-230-8743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fe6-71f1-b6c2-89884e6cbfa9",
        "storage_key": "property/6767906449166324/019d0268-1fe6-71f1-b6c2-89884e6cbfa9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA4RPcTMSsYkRynmnVgwI3l8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4103ba24-c35f-4924-92da-29b36f47c32c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "6409 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "Chain stocking fresh produce and meats, plus prepared foods and organic goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1508-7270-b8ae-ddcbb96c0082.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-1508-7270-b8ae-ddcbb96c0082",
        "storage_key": "property/6767906449166324/019fce00-1508-7270-b8ae-ddcbb96c0082.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/va/richmond/6409-jahnke-rd.?y_source=1_NTA0NjYxMi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8144162747918315956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "37.518715",
      "poi_longitude": "-77.514603",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-320-0996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fef-7747-961b-4ef02c89e20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fef-7747-961b-4ef02c89e20e",
        "storage_key": "property/6767906449166324/019d0268-1fef-7747-961b-4ef02c89e20e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU-dlEFYSsYkRtPGjnt7gBXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cde33cd6-7ce8-4c8c-8ff2-1684d640bdf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "6335 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-14a7-733f-9cd0-dc70e650f073.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-14a7-733f-9cd0-dc70e650f073",
        "storage_key": "property/6767906449166324/019fce00-14a7-733f-9cd0-dc70e650f073.webp",
        "width": 971,
        "height": 1280
      },
      "poi_business_url": "https://locations.dollartree.com/va/richmond/6335-jahnke-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7035972517501208820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "37.5193701",
      "poi_longitude": "-77.5134813",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-215-3425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2404-76ff-8c7d-92e7884b25a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2404-76ff-8c7d-92e7884b25a5",
        "storage_key": "property/6767906449166324/019d0268-2404-76ff-8c7d-92e7884b25a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNQ8egS0TsYkR9AgS-7nLpGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e3ccd2d8-6ff1-45b2-9e11-5221fe0f14ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Rite Aid",
      "poi_type": "Shopping & Retail",
      "poi_address": "6335 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1489-732c-883a-38b39a0a48b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-1489-732c-883a-38b39a0a48b7",
        "storage_key": "property/6767906449166324/019fce00-1489-732c-883a-38b39a0a48b7.webp",
        "width": 251,
        "height": 250
      },
      "poi_business_url": "https://locations.riteaid.com/locations/va/richmond/6335-jahnke-road.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3511531545189936352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rite-aid",
      "poi_latitude": "37.5193661",
      "poi_longitude": "-77.5134643",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-320-5871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdQHY1YSsYkR4Oyf4FV3uzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a121d75b-4702-45e7-8b4f-6510c041f321",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1214 Westover Hills Blvd, Richmond, VA 23225, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-16f2-77e1-a6b2-cff6f8063e01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-16f2-77e1-a6b2-cff6f8063e01",
        "storage_key": "property/6767906449166324/019fce00-16f2-77e1-a6b2-cff6f8063e01.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1214+westover+hills+blvd-richmond-va-23225/id=3681",
      "poi_directions_map_url": "https://maps.google.com/?cid=5107526904815324487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "37.5206506",
      "poi_longitude": "-77.4892437",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-230-6335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9XM7jTQSsYkRR41EuqiU4UY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3acc18bf-ea75-4321-9345-e8a45a0f41fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5001 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1aaf-73d9-8141-2e0417f8b49d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-1aaf-73d9-8141-2e0417f8b49d",
        "storage_key": "property/6767906449166324/019fce00-1aaf-73d9-8141-2e0417f8b49d.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richmond-va-pharmacies/5001-forest-hill-avenue-richmond-va-23225/storeid=1989?WT.mc_id=LS_GOOGLE_RX_1989",
      "poi_directions_map_url": "https://maps.google.com/?cid=12691097514468981491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.5218034",
      "poi_longitude": "-77.4890628",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-232-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2547-76dd-8407-6ad5cd5e0299.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2547-76dd-8407-6ad5cd5e0299",
        "storage_key": "property/6767906449166324/019d0268-2547-76dd-8407-6ad5cd5e0299.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyybWwDQSsYkR8zrE9_LVH7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_445e67f0-4142-49af-be46-6350fb7a129d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "7319 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1b82-722c-9932-01915cea38b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-1b82-722c-9932-01915cea38b3",
        "storage_key": "property/6767906449166324/019fce00-1b82-722c-9932-01915cea38b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.aldi.us/va/richmond/7319-forest-hill-avenue?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=10337911520563774235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "37.5365188",
      "poi_longitude": "-77.53140719999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fef-7747-961b-4ef02c89e20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fef-7747-961b-4ef02c89e20e",
        "storage_key": "property/6767906449166324/019d0268-1fef-7747-961b-4ef02c89e20e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWWEXRoTsYkRG0OfXsGjd48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9c62d558-6d95-4f2a-a2ea-d93c143bfcab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2410 Sheila Ln, Richmond, VA 23225, USA",
      "poi_short_description": "Vast chain of general retailers: offering groceries, clothing, electronics, hardware, home goods, toys, sporting goods, and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1c12-7439-a2e9-844b525cec96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-1c12-7439-a2e9-844b525cec96",
        "storage_key": "property/6767906449166324/019fce00-1c12-7439-a2e9-844b525cec96.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2821-richmond-va/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6792109250055986809&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "37.5324683",
      "poi_longitude": "-77.53213170000001",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-320-6991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2404-76ff-8c7d-92e7884b25a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2404-76ff-8c7d-92e7884b25a5",
        "storage_key": "property/6767906449166324/019d0268-2404-76ff-8c7d-92e7884b25a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEWcTshsTsYkReV47dWBrQl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_097eeebc-e8d7-426a-909d-8d3692ea0a0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Publix Super Market at Carytown Exchange",
      "poi_type": "Shopping & Retail",
      "poi_address": "3535 Ellwood Ave, Richmond, VA 23221, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1da7-75cb-bab8-853a571f305d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-1da7-75cb-bab8-853a571f305d",
        "storage_key": "property/6767906449166324/019fce00-1da7-75cb-bab8-853a571f305d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1588&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=13593844236544353470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-carytown-exchange",
      "poi_latitude": "37.5569683",
      "poi_longitude": "-77.487985",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-253-6372",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-1fef-7747-961b-4ef02c89e20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-1fef-7747-961b-4ef02c89e20e",
        "storage_key": "property/6767906449166324/019d0268-1fef-7747-961b-4ef02c89e20e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2PFolcTsYkRvqQ3U08Jp7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_07c49e4e-fd8a-4c94-a124-1dc3d4f1be11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Elizabeth D Redd Elem School",
      "poi_type": "Education",
      "poi_address": "5601 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-2127-755c-b2c0-51b3933d3149.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-2127-755c-b2c0-51b3933d3149",
        "storage_key": "property/6767906449166324/019fce00-2127-755c-b2c0-51b3933d3149.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://edres.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3234360757738547265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elizabeth-d-redd-elem-school",
      "poi_latitude": "37.5161007",
      "poi_longitude": "-77.50281799999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-780-5061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJc2xu08SsYkRQSh4CPnB4iw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3855db91-b763-4220-bd0b-40552d2602ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Lucille M. Brown Middle School",
      "poi_type": "Education",
      "poi_address": "6300 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://lbms.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10464772117655344547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucille-m-brown-middle-school",
      "poi_latitude": "37.5213469",
      "poi_longitude": "-77.5134118",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-319-3013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ818FuVUSsYkRo1VC2MtWOpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fcd5db10-afc8-4595-9b88-6c3d61721f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Huguenot High School",
      "poi_type": "Education",
      "poi_address": "7945 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-229b-71c8-9f27-c9a3d7755c74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-229b-71c8-9f27-c9a3d7755c74",
        "storage_key": "property/6767906449166324/019fce00-229b-71c8-9f27-c9a3d7755c74.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://hhs.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11119870295197413264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huguenot-high-school",
      "poi_latitude": "37.5323924",
      "poi_longitude": "-77.54257559999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-320-7967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLx5j-SATsYkRkO-oLR63UZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_05a037ed-e483-45fc-8935-4526b75c945d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Leave It To Beaver Child Care",
      "poi_type": "Education",
      "poi_address": "730 German School Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-21e8-7027-b40e-e31b9740acb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-21e8-7027-b40e-e31b9740acb1",
        "storage_key": "property/6767906449166324/019fce00-21e8-7027-b40e-e31b9740acb1.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.leaveittobvr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10560655663288481254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leave-it-to-beaver-child-care",
      "poi_latitude": "37.5140743",
      "poi_longitude": "-77.50976159999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 804-944-8799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvQmoHFoSsYkR5vWGfV_8jpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_88a444b8-02bf-42c5-9a34-442ac68d5b81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "The Village Richmond",
      "poi_type": "Education",
      "poi_address": "3318 W Cary St, Richmond, VA 23221, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-2375-703f-8ce3-6f7b295b9a83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-2375-703f-8ce3-6f7b295b9a83",
        "storage_key": "property/6767906449166324/019fce00-2375-703f-8ce3-6f7b295b9a83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thevillagerichmond.com/?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16312224892897682759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-village-richmond",
      "poi_latitude": "37.55479280000001",
      "poi_longitude": "-77.4845596",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 703-649-0148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1cKd4WUTsYkRR2VzPR2qYOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9f74d677-7f88-413f-aa81-3b2bb19b8f64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Southampton Elementary School",
      "poi_type": "Education",
      "poi_address": "3333 Cheverly Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://shes.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13314915739170945513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southampton-elementary-school",
      "poi_latitude": "37.5441281",
      "poi_longitude": "-77.5340858",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-320-2434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQbI-BhQTsYkR6bmKv1EVyLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0984cebf-7ce0-4e56-b801-a34566696c3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Elijah House Academy",
      "poi_type": "Education",
      "poi_address": "6627-B Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.elijahhouseacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16102428742641366024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elijah-house-academy",
      "poi_latitude": "37.5172383",
      "poi_longitude": "-77.5184244",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-755-7051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI5FcSGESsYkRCLQtiqBRd98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1eee19eb-408d-48fd-8c89-d38cfb4d5ff0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Good Shepherd Episcopal School",
      "poi_type": "Education",
      "poi_address": "4207 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-291c-77b8-8749-93d0fc62ff2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-291c-77b8-8749-93d0fc62ff2b",
        "storage_key": "property/6767906449166324/019fce00-291c-77b8-8749-93d0fc62ff2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gses.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5765875173556740141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "good-shepherd-episcopal-school",
      "poi_latitude": "37.5188847",
      "poi_longitude": "-77.4789917",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-231-1452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNyUnqi0SsYkRLeAX4-uABFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ee8fcfc-c187-4b64-86b3-590de2398d61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Richmond Waldorf School",
      "poi_type": "Education",
      "poi_address": "1301 Robin Hood Rd, Richmond, VA 23227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-2982-7635-af0b-2404c17490b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-2982-7635-af0b-2404c17490b8",
        "storage_key": "property/6767906449166324/019fce00-2982-7635-af0b-2404c17490b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.richmondwaldorf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11357887947756895560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-waldorf-school",
      "poi_latitude": "37.5718768",
      "poi_longitude": "-77.4532217",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-377-8024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp6RgIzQSsYkRSH29bOlSn50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3cb2a7c1-02d2-4059-8cf9-bdb42b2a88de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Patrick Henry School of Science & Arts",
      "poi_type": "Education",
      "poi_address": "3411 Semmes Ave, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-2952-7254-a8fe-c4895b711b4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-2952-7254-a8fe-c4895b711b4b",
        "storage_key": "property/6767906449166324/019fce00-2952-7254-a8fe-c4895b711b4b.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "http://www.patrickhenrycharter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2743634727755546297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patrick-henry-school-of-science--arts",
      "poi_latitude": "37.5162287",
      "poi_longitude": "-77.46986009999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-888-7061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf5OavoERsYkRuX5LnT9ZEyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f60dff8f-c027-4848-8934-29de994ff6fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "The Byrd Theatre",
      "poi_type": "Entertainment",
      "poi_address": "2908 W Cary St, Richmond, VA 23221, USA",
      "poi_short_description": "An historic landmark, this opulent 1928 movie palace now shows second-run films in grand style.",
      "poi_long_description": "An historic landmark, this opulent 1928 movie palace now shows second-run films in grand style.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-2a1e-77b8-b34e-003f9f1b389e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-2a1e-77b8-b34e-003f9f1b389e",
        "storage_key": "property/6767906449166324/019fce00-2a1e-77b8-b34e-003f9f1b389e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://byrdtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9894436379511868258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-byrd-theatre",
      "poi_latitude": "37.552441",
      "poi_longitude": "-77.4778413",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-358-3056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-27fd-70ff-b03b-2a8740c2e53f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-27fd-70ff-b03b-2a8740c2e53f",
        "storage_key": "property/6767906449166324/019d0268-27fd-70ff-b03b-2a8740c2e53f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJd1T2xOQTsYkRYsuB1XYZUIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e34919f-91ea-4f21-ad8a-9dffa89e6770",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Virginia Museum of Fine Arts",
      "poi_type": "Entertainment",
      "poi_address": "200 N Arthur Ashe Blvd, Richmond, VA 23220, USA",
      "poi_short_description": "Museum with a varied, sizable collection of modern art, antiquities & Asian art, plus Fabergé eggs.",
      "poi_long_description": "Museum with a varied, sizable collection of modern art, antiquities & Asian art, plus Fabergé eggs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-2ebd-72b9-bb58-6f38d1463b67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-2ebd-72b9-bb58-6f38d1463b67",
        "storage_key": "property/6767906449166324/019fce00-2ebd-72b9-bb58-6f38d1463b67.webp",
        "width": 681,
        "height": 458
      },
      "poi_business_url": "https://vmfa.museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4695707663755383770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-museum-of-fine-arts",
      "poi_latitude": "37.5560356",
      "poi_longitude": "-77.4747907",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-340-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28e2-746d-8036-a4bf0a3fb044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28e2-746d-8036-a4bf0a3fb044",
        "storage_key": "property/6767906449166324/019d0268-28e2-746d-8036-a4bf0a3fb044.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1Bd8_wTsYkR2hM4wz2BKkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ef660503-f8ff-4935-980d-b82c8318e71b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Science Museum of Virginia",
      "poi_type": "Entertainment",
      "poi_address": "2500 W Broad St, Richmond, VA 23220, USA",
      "poi_short_description": "Kid-focused, hands-on exhibits about animals, the human body, the cosmos & the environment.",
      "poi_long_description": "Kid-focused, hands-on exhibits about animals, the human body, the cosmos & the environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-30eb-76bc-b6b8-5f5a7985e3ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-30eb-76bc-b6b8-5f5a7985e3ff",
        "storage_key": "property/6767906449166324/019fce00-30eb-76bc-b6b8-5f5a7985e3ff.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "http://www.smv.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10474820232218678101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "science-museum-of-virginia",
      "poi_latitude": "37.5610827",
      "poi_longitude": "-77.4657929",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-864-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28e2-746d-8036-a4bf0a3fb044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28e2-746d-8036-a4bf0a3fb044",
        "storage_key": "property/6767906449166324/019d0268-28e2-746d-8036-a4bf0a3fb044.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9jmx1QRsYkRVRN404AJXpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_915536bf-ea6c-4087-825f-a54b957260cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Maymont",
      "poi_type": "Entertainment",
      "poi_address": "1700 Hampton St, Richmond, VA 23220, USA",
      "poi_short_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_long_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3124-76ad-a5eb-9887e19c983f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3124-76ad-a5eb-9887e19c983f",
        "storage_key": "property/6767906449166324/019fce00-3124-76ad-a5eb-9887e19c983f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://maymont.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4834827198225545156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maymont",
      "poi_latitude": "37.5341784",
      "poi_longitude": "-77.474571",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-525-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28f0-7151-85c8-dfd88e37cef9",
        "storage_key": "property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8TfDdkTsYkRxHehhLjBGEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_71a13d39-2cc2-46cd-aec7-4d27d884b497",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Lewis Ginter Botanical Garden",
      "poi_type": "Entertainment",
      "poi_address": "1800 Lakeside Ave, Henrico, VA 23228, USA",
      "poi_short_description": "Year-round locale with 50 acres of themed gardens, dining options & a classical domed conservatory.",
      "poi_long_description": "Year-round locale with 50 acres of themed gardens, dining options & a classical domed conservatory.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3143-746d-9aa1-f068367612ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3143-746d-9aa1-f068367612ff",
        "storage_key": "property/6767906449166324/019fce00-3143-746d-9aa1-f068367612ff.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.lewisginter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5246604299070095794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewis-ginter-botanical-garden",
      "poi_latitude": "37.621294",
      "poi_longitude": "-77.47107849999999",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-262-9887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28f0-7151-85c8-dfd88e37cef9",
        "storage_key": "property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-ByrtgVsYkRskEc88-uz0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2c072343-0d6d-4f22-9108-37772045db8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "The National",
      "poi_type": "Entertainment",
      "poi_address": "708 E Broad St, Richmond, VA 23219, USA",
      "poi_short_description": "Ornate, renovated 1920s theater now hosting medium-sized music shows & other performances.",
      "poi_long_description": "Ornate, renovated 1920s theater now hosting medium-sized music shows & other performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3468-763a-baa2-4c3341379a57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3468-763a-baa2-4c3341379a57",
        "storage_key": "property/6767906449166324/019fce00-3468-763a-baa2-4c3341379a57.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thenationalva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10004828295590865461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-national",
      "poi_latitude": "37.541897",
      "poi_longitude": "-77.43517",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-612-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UdhNiMRsYkRNWp4tVNK2Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1a2ecbc7-cbee-4eb1-8e7b-d04704acb78f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Altria Theater",
      "poi_type": "Entertainment",
      "poi_address": "6 N Laurel St, Richmond, VA 23220, USA",
      "poi_short_description": "Sizable theater on the VA Commonwealth campus, offering musicals, concerts, comedy & other events.",
      "poi_long_description": "Sizable theater on the VA Commonwealth campus, offering musicals, concerts, comedy & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3753-760d-aa42-120136fbcb7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3753-760d-aa42-120136fbcb7f",
        "storage_key": "property/6767906449166324/019fce00-3753-760d-aa42-120136fbcb7f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.altriatheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6861660426167536636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "altria-theater",
      "poi_latitude": "37.5461984",
      "poi_longitude": "-77.4516976",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-592-3368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfBBlEYRsYkR_EsSj82DOV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_afff4e44-4d71-4560-848c-7a2af6d515de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Ember Music Hall",
      "poi_type": "Entertainment",
      "poi_address": "309 E Broad St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-388c-727d-a343-e7fe0cc3227d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-388c-727d-a343-e7fe0cc3227d",
        "storage_key": "property/6767906449166324/019fce00-388c-727d-a343-e7fe0cc3227d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://embermusichall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4611222739956325618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ember-music-hall",
      "poi_latitude": "37.5434971",
      "poi_longitude": "-77.43912720000002",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-404-2327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEy4rCS0RsYkR8txMk6Za_j8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_33e8c775-e4d5-4ba7-aed4-443dd07e681a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "The Broadberry",
      "poi_type": "Entertainment",
      "poi_address": "2729 W Broad St, Richmond, VA 23220, USA",
      "poi_short_description": "Modest concert venue hosting local & touring acts, plus a small pub grub menu & full bar.",
      "poi_long_description": "Modest concert venue hosting local & touring acts, plus a small pub grub menu & full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-38ad-70fc-8e68-e77090660c51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-38ad-70fc-8e68-e77090660c51",
        "storage_key": "property/6767906449166324/019fce00-38ad-70fc-8e68-e77090660c51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebroadberry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6871247635338204732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadberry",
      "poi_latitude": "37.5616733",
      "poi_longitude": "-77.4695045",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-353-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJizauXFURsYkRPJYTpFGTW18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c9ffdf18-d77c-4f0f-8854-58099583f21a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Hippodrome Theater",
      "poi_type": "Entertainment",
      "poi_address": "528 N 2nd St, Richmond, VA 23219, USA",
      "poi_short_description": "Entertainment venue & lounge housed in a renovated vaudeville theater with hints of 1914 glamour.",
      "poi_long_description": "Entertainment venue & lounge housed in a renovated vaudeville theater with hints of 1914 glamour.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3af4-745b-a2ab-33c80a7e78e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3af4-745b-a2ab-33c80a7e78e3",
        "storage_key": "property/6767906449166324/019fce00-3af4-745b-a2ab-33c80a7e78e3.webp",
        "width": 1248,
        "height": 830
      },
      "poi_business_url": "http://www.hippodromerichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14015178720581210976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hippodrome-theater",
      "poi_latitude": "37.5472611",
      "poi_longitude": "-77.4380472",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-308-2913",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Vc48joRsYkRYFPbb8rqf8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_75a67e83-ae2d-4343-af26-b8516d0a738d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Chippenham Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7101 Jahnke Rd E, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3c47-7418-b384-28403548066f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3c47-7418-b384-28403548066f",
        "storage_key": "property/6767906449166324/019fce00-3c47-7418-b384-28403548066f.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/chippenham-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643199243469856749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chippenham-hospital",
      "poi_latitude": "37.5135368",
      "poi_longitude": "-77.5261508",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-483-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2901-71b9-964b-abe7236c675a",
        "storage_key": "property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2uycvASsYkR7R-ObjcZEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9ae460ed-e2ff-4a52-a78d-f5ccc47c7b9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Johnston-Willis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1401 Johnston Willis Dr, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3f3e-7358-8a2c-03d2ae3cc925.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3f3e-7358-8a2c-03d2ae3cc925",
        "storage_key": "property/6767906449166324/019fce00-3f3e-7358-8a2c-03d2ae3cc925.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/johnston-willis-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18321833032577784974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnston-willis-hospital",
      "poi_latitude": "37.510606",
      "poi_longitude": "-77.5946555",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-483-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2901-71b9-964b-abe7236c675a",
        "storage_key": "property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDx25C21tsYkRjhzR5BE6RP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dc664011-d059-4a7b-b998-101a0b0641f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "MedExpress Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4903 Nine Mile Rd, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3eaf-75fe-b322-04a2f3cc3b8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3eaf-75fe-b322-04a2f3cc3b8e",
        "storage_key": "property/6767906449166324/019fce00-3eaf-75fe-b322-04a2f3cc3b8e.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.medexpressurgentcare.com/location/va/richmond/rcv?utm_campaign=MX_Brand_2021&utm_medium=NPS&utm_source=YEXT&utm_term=2021adi6c3az19",
      "poi_directions_map_url": "https://maps.google.com/?cid=14305336813036312838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medexpress-urgent-care",
      "poi_latitude": "37.5450096",
      "poi_longitude": "-77.36743919999999",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 804-222-3549",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT7wH0wQasYkRBhlZ3QnEhsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_62e8371c-7b8d-4014-add4-ca9f0b1994fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Laburnum Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4620 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-41ad-71aa-b8fb-cf6db3c7f683.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-41ad-71aa-b8fb-cf6db3c7f683",
        "storage_key": "property/6767906449166324/019fce00-41ad-71aa-b8fb-cf6db3c7f683.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bonsecours.com/locations/primary-care-family-medicine/richmond/laburnum-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=5018483097953376492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "laburnum-medical-center",
      "poi_latitude": "37.5256261",
      "poi_longitude": "-77.3554271",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 804-226-2444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aUZh_oXsYkR7BjQ3Mk7pUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4da97c16-172d-4713-b116-ebd13a76a628",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5001 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1aaf-73d9-8141-2e0417f8b49d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-1aaf-73d9-8141-2e0417f8b49d",
        "storage_key": "property/6767906449166324/019fce00-1aaf-73d9-8141-2e0417f8b49d.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richmond-va-pharmacies/5001-forest-hill-avenue-richmond-va-23225/storeid=1989?WT.mc_id=LS_GOOGLE_RX_1989",
      "poi_directions_map_url": "https://maps.google.com/?cid=12691097514468981491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.5218034",
      "poi_longitude": "-77.4890628",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-232-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2547-76dd-8407-6ad5cd5e0299.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2547-76dd-8407-6ad5cd5e0299",
        "storage_key": "property/6767906449166324/019d0268-2547-76dd-8407-6ad5cd5e0299.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyybWwDQSsYkR8zrE9_LVH7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_862c10a7-10ae-4b14-a7ea-89363ad061f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5100 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1aaf-73d9-8141-2e0417f8b49d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-1aaf-73d9-8141-2e0417f8b49d",
        "storage_key": "property/6767906449166324/019fce00-1aaf-73d9-8141-2e0417f8b49d.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richmond-va-pharmacies/5100-s-laburnum-ave-laburnum-square-richmond-va-23231/storeid=1976?WT.mc_id=LS_GOOGLE_RX_1976",
      "poi_directions_map_url": "https://maps.google.com/?cid=4876978380975811458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.5167867",
      "poi_longitude": "-77.3504999",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 804-222-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2547-76dd-8407-6ad5cd5e0299.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2547-76dd-8407-6ad5cd5e0299",
        "storage_key": "property/6767906449166324/019d0268-2547-76dd-8407-6ad5cd5e0299.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzUkl1wasYkRgqtSh_-BrkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ace176be-560c-43ed-bea8-88bd491e5797",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1214 Westover Hills Blvd, Richmond, VA 23225, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-4318-70e8-acae-158e11464e82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-4318-70e8-acae-158e11464e82",
        "storage_key": "property/6767906449166324/019fce00-4318-70e8-acae-158e11464e82.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1214+westover+hills+blvd-richmond-va-23225/id=3681",
      "poi_directions_map_url": "https://maps.google.com/?cid=9613431719425760712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "37.5206485",
      "poi_longitude": "-77.48925559999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-230-6335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2547-76dd-8407-6ad5cd5e0299.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2547-76dd-8407-6ad5cd5e0299",
        "storage_key": "property/6767906449166324/019d0268-2547-76dd-8407-6ad5cd5e0299.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bZo8TQSsYkRyF3Y9DbFaYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d7f9ff9-7d44-4633-8cb0-60edf4c2731c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7101 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Chain fitness center offering a range of equipment, personal training, and 24/7 access.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-44c4-72c9-8346-97306e03b466.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-44c4-72c9-8346-97306e03b466",
        "storage_key": "property/6767906449166324/019fce00-44c4-72c9-8346-97306e03b466.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/richmond-virginia-3652/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=3652",
      "poi_directions_map_url": "https://maps.google.com/?cid=14493859207698867019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "37.5346358",
      "poi_longitude": "-77.52650229999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-404-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWBI3gQTsYkRS2NqWyiIJMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a5186697-c04c-4a23-aff0-1cfa764878c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "MMA Institute",
      "poi_type": "Health and Wellness",
      "poi_address": "6415 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-4578-77fd-b2d0-b7c419af1ec1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-4578-77fd-b2d0-b7c419af1ec1",
        "storage_key": "property/6767906449166324/019fce00-4578-77fd-b2d0-b7c419af1ec1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mmainstitute.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6184493133869282453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mma-institute",
      "poi_latitude": "37.5191523",
      "poi_longitude": "-77.51564549999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 804-330-3424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEzaJGFYSsYkRlfQeCL2701U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c4991632-f3a9-4efc-b19f-cdc593ade83a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Pilates Fitness Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "1520 W Main St #106, Richmond, VA 23220, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-48ac-7305-8729-cf551940b8cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-48ac-7305-8729-cf551940b8cd",
        "storage_key": "property/6767906449166324/019fce00-48ac-7305-8729-cf551940b8cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thepilatesfitnessstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16026975387284319114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilates-fitness-studio",
      "poi_latitude": "37.5475839",
      "poi_longitude": "-77.46044760000001",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-363-8467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTZoWFFsRsYkRiqsCPzNBa94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_14317a10-471a-4628-9323-6dc28f52a7d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "James River Park Pony Pasture",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Richmond, VA 23225, USA",
      "poi_short_description": "Riverside park featuring scenic trails for biking and hiking, as well as swimming.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-4a2f-711e-92ba-82a336af4911.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-4a2f-711e-92ba-82a336af4911",
        "storage_key": "property/6767906449166324/019fce00-4a2f-711e-92ba-82a336af4911.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://jamesriverpark.org/explore-the-park-pony-pasture/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12267777557924412234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-river-park-pony-pasture",
      "poi_latitude": "37.5506636",
      "poi_longitude": "-77.51756619999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28f0-7151-85c8-dfd88e37cef9",
        "storage_key": "property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgXjOv3UTsYkRSvuXA7HmP6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ddd6a8da-34e9-4116-8873-0dce62e7e8c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Huguenot Flatwater Parking Lot",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Huguenot Flatwater Parking Lot, Southampton Rd, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14927151082810316259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huguenot-flatwater-parking-lot",
      "poi_latitude": "37.55996469999999",
      "poi_longitude": "-77.5457307",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUatmsUQTsYkR4xV_h9LkJ88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a9d7d5ed-b8fb-4419-939f-22b506344f30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Reedy Creek Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4001 N Riverside Dr, Richmond, VA 23225, USA",
      "poi_short_description": "Parking lot & staging area for a scenic nature hike along a channel of the James River.",
      "poi_long_description": "Parking lot & staging area for a scenic nature hike along a channel of the James River.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-4b9d-7532-b429-0c9ad648c99b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-4b9d-7532-b429-0c9ad648c99b",
        "storage_key": "property/6767906449166324/019fce00-4b9d-7532-b429-0c9ad648c99b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15227270792784847381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reedy-creek-trailhead",
      "poi_latitude": "37.5243026",
      "poi_longitude": "-77.46869269999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-646-5733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28f0-7151-85c8-dfd88e37cef9",
        "storage_key": "property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUx4_eNUTsYkRFSKfxhsiUtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_962ba6e9-80f2-4d03-9b81-78d49a2c33bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Forest Hill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4021 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Partial wetland area with a historic home, nature trails, wildlife, tennis courts, picnics & events.",
      "poi_long_description": "Partial wetland area with a historic home, nature trails, wildlife, tennis courts, picnics & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-4cbd-7557-8767-863e65892eeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-4cbd-7557-8767-863e65892eeb",
        "storage_key": "property/6767906449166324/019fce00-4cbd-7557-8767-863e65892eeb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rva.gov/parks-recreation/forest-hill-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4852190897879243188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest-hill-park",
      "poi_latitude": "37.5207992",
      "poi_longitude": "-77.4763246",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-646-0036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28f0-7151-85c8-dfd88e37cef9",
        "storage_key": "property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQ1A5CoSsYkRtNl54ulxVkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a5091b54-690b-4bc4-8d25-0ea4367930a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Phideaux Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4401 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Fenced, dog-centric park with tennis balls, a kiddie pool and water bowls.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-5041-76eb-9641-b558f29e48fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-5041-76eb-9641-b558f29e48fd",
        "storage_key": "property/6767906449166324/019fce00-5041-76eb-9641-b558f29e48fd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9835198125175101753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phideaux-dog-park",
      "poi_latitude": "37.5198579",
      "poi_longitude": "-77.4810043",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28f0-7151-85c8-dfd88e37cef9",
        "storage_key": "property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxaPei0SsYkROVmm8pWkfYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_faa146d3-6613-4355-ade5-986ce3091d61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "2099 Riverside Dr",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2099 Riverside Dr, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?q=2099+Riverside+Dr,+Richmond,+VA+23225,+USA&ftid=0x89b111712b9d5d13:0x30bbbc00c143aab4&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "2099-riverside-dr",
      "poi_latitude": "37.5244525",
      "poi_longitude": "-77.45597149999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "EioyMDk5IFJpdmVyc2lkZSBEciwgUmljaG1vbmQsIFZBIDIzMjI1LCBVU0EiMRIvChQKEgkTXZ0rcRGxiRGCne2c0wfvqRCzECoUChIJKfMVMNETsYkR-ZV_v5fGCpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_866acb98-0779-4da4-94a9-bbebbd836756",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Powhite Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7200 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "City park featuring multi-use trails amid lush green space, plus a parking area.",
      "poi_long_description": "City park featuring multi-use trails amid lush green space, plus a parking area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-5290-747d-863f-850d7f63319c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-5290-747d-863f-850d7f63319c",
        "storage_key": "property/6767906449166324/019fce00-5290-747d-863f-850d7f63319c.webp",
        "width": 970,
        "height": 1280
      },
      "poi_business_url": "https://www.visitrichmondva.com/listing/powhite-park/3312/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15560776727965493264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "powhite-park",
      "poi_latitude": "37.5235511",
      "poi_longitude": "-77.5237518",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-646-5733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28f0-7151-85c8-dfd88e37cef9",
        "storage_key": "property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-SnxIvwSsYkREGiMU_378tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9066ade1-092e-402b-8c87-69a5aabd3ee6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Ancarrow's Landing",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1200 Brander St, Richmond, VA 23224, USA",
      "poi_short_description": "This functional waterfront space offers a boat launch, fishing access & a network of trails.",
      "poi_long_description": "This functional waterfront space offers a boat launch, fishing access & a network of trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-5371-716d-b950-1072ab092ce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-5371-716d-b950-1072ab092ce6",
        "storage_key": "property/6767906449166324/019fce00-5371-716d-b950-1072ab092ce6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.jamesriverpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5256169693123061680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ancarrows-landing",
      "poi_latitude": "37.5202081",
      "poi_longitude": "-77.41891710000002",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28f0-7151-85c8-dfd88e37cef9",
        "storage_key": "property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6vpp_4QsYkRsCfGzXyq8Ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e670a966-6e01-4b35-aa32-3aeee2f70b3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "The Robins Nature Center at Maymont",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2201 Shields Lake Dr, Richmond, VA 23220, USA",
      "poi_short_description": "Wildlife center conserving aquatic animals, fish & reptiles offering weekend animal encounters.",
      "poi_long_description": "Wildlife center conserving aquatic animals, fish & reptiles offering weekend animal encounters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-53cc-7437-ba3d-3ca407037cfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-53cc-7437-ba3d-3ca407037cfb",
        "storage_key": "property/6767906449166324/019fce00-53cc-7437-ba3d-3ca407037cfb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://maymont.org/what-to-see/nature-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17541122481027984313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-robins-nature-center-at-maymont",
      "poi_latitude": "37.5373937",
      "poi_longitude": "-77.4755181",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-525-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28f0-7151-85c8-dfd88e37cef9",
        "storage_key": "property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2Cmr94TsYkRuatKq_WVbvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eb523a1a-fd5b-4323-bb09-4853b844c5cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Byrd Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 S Arthur Ashe Blvd, Richmond, VA 23220, USA",
      "poi_short_description": "Picturesque city park offering 3 lakes, a walking path, picnic areas, athletic fields & more.",
      "poi_long_description": "Picturesque city park offering 3 lakes, a walking path, picnic areas, athletic fields & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-57bc-778e-a293-fd4158b14116.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-57bc-778e-a293-fd4158b14116",
        "storage_key": "property/6767906449166324/019fce00-57bc-778e-a293-fd4158b14116.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.rva.gov/parks-recreation/byrd-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12837632018604371955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "byrd-park",
      "poi_latitude": "37.5427152",
      "poi_longitude": "-77.4795668",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-646-5733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-28f0-7151-85c8-dfd88e37cef9",
        "storage_key": "property/6767906449166324/019d0268-28f0-7151-85c8-dfd88e37cef9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7oHsZILsYkR8y8Y4k1uKLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f0a25cd5-d7b6-4373-b2e4-1f083898e391",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "GRTC",
      "poi_type": "Transportation & Transit",
      "poi_address": "301 E Belt Blvd, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-59f9-709f-83ee-86514823bc28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-59f9-709f-83ee-86514823bc28",
        "storage_key": "property/6767906449166324/019fce00-59f9-709f-83ee-86514823bc28.webp",
        "width": 1000,
        "height": 380
      },
      "poi_business_url": "http://www.ridegrtc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16451363726910217568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grtc",
      "poi_latitude": "37.5066205",
      "poi_longitude": "-77.478867",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-358-4782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2E1riESsYkRYN06hSX8TuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5d46cd8b-1dd7-47f0-a520-3b2b61ed5e70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Jahnke + German School",
      "poi_type": "Transportation & Transit",
      "poi_address": "Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3426804007646566375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jahnke--german-school",
      "poi_latitude": "37.51971",
      "poi_longitude": "-77.515703",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6NeG1YSsYkR55eoxhZ0ji8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9f6ed88f-8359-4350-9baa-805867c76847",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Downtown Transfer Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "808 E Clay St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-5afe-75e5-b72c-88f9d1468eb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-5afe-75e5-b72c-88f9d1468eb0",
        "storage_key": "property/6767906449166324/019fce00-5afe-75e5-b72c-88f9d1468eb0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://ridegrtc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16855104016612525274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transfer-station",
      "poi_latitude": "37.543349",
      "poi_longitude": "-77.432102",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-358-4782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJExmQaqgRsYkR2gRzCs1b6ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8edfb182-34f4-4814-9738-3fa8552a10f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Richmond Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1500 E Main St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-5ac7-715e-b59c-3db16ae21705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-5ac7-715e-b59c-3db16ae21705",
        "storage_key": "property/6767906449166324/019fce00-5ac7-715e-b59c-3db16ae21705.webp",
        "width": 1280,
        "height": 1237
      },
      "poi_business_url": "https://www.amtrak.com/stations/rvm.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11973413221483929113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-main-street-station",
      "poi_latitude": "37.5351005",
      "poi_longitude": "-77.4287069",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8r0xR4RsYkRGd6DF-MbKqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_91024fc4-81f1-4986-8551-d37a69ccb64c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Richmond Staples Mill Road",
      "poi_type": "Transportation & Transit",
      "poi_address": "7519 Staples Mill Rd, Richmond, VA 23228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-5df6-71be-a911-1f66aa077ef0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-5df6-71be-a911-1f66aa077ef0",
        "storage_key": "property/6767906449166324/019fce00-5df6-71be-a911-1f66aa077ef0.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://www.amtrak.com/stations/rvr",
      "poi_directions_map_url": "https://maps.google.com/?cid=5387222506202384095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-staples-mill-road",
      "poi_latitude": "37.6177745",
      "poi_longitude": "-77.49697019999999",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubZoY7cVsYkR38YuoFNCw0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_33b9d6c8-b47e-4bb0-a44c-f4d8e8a771a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Richmond International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Richard E Byrd Terminal Dr, Richmond, VA 23250, USA",
      "poi_short_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_long_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-600f-72e8-905c-5182c715a0c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-600f-72e8-905c-5182c715a0c1",
        "storage_key": "property/6767906449166324/019fce00-600f-72e8-905c-5182c715a0c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyrichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6449714593814021840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-international-airport",
      "poi_latitude": "37.5105562",
      "poi_longitude": "-77.3266991",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 804-226-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2b7b-7403-a0a9-9316f19f955a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2b7b-7403-a0a9-9316f19f955a",
        "storage_key": "property/6767906449166324/019d0268-2b7b-7403-a0a9-9316f19f955a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dzDsqwbsYkR0AbwQkD9gVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fef72f8b-6d11-4941-90f9-a455c390ba3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Chippenham Hospital",
      "poi_type": "Transportation & Transit",
      "poi_address": "7101 Jahnke Rd E, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3c47-7418-b384-28403548066f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3c47-7418-b384-28403548066f",
        "storage_key": "property/6767906449166324/019fce00-3c47-7418-b384-28403548066f.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/chippenham-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643199243469856749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chippenham-hospital",
      "poi_latitude": "37.5135368",
      "poi_longitude": "-77.5261508",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-483-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2901-71b9-964b-abe7236c675a",
        "storage_key": "property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2uycvASsYkR7R-ObjcZEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5e5b13e4-fbb0-4f21-b598-7ce00334736f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Chippenham Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7101 Jahnke Rd E, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3c47-7418-b384-28403548066f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3c47-7418-b384-28403548066f",
        "storage_key": "property/6767906449166324/019fce00-3c47-7418-b384-28403548066f.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/chippenham-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643199243469856749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chippenham-hospital",
      "poi_latitude": "37.5135368",
      "poi_longitude": "-77.5261508",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-483-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2901-71b9-964b-abe7236c675a",
        "storage_key": "property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2uycvASsYkR7R-ObjcZEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b019c6cd-27ad-4678-80c1-62f6315128dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Johnston-Willis Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1401 Johnston Willis Dr, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3f3e-7358-8a2c-03d2ae3cc925.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-3f3e-7358-8a2c-03d2ae3cc925",
        "storage_key": "property/6767906449166324/019fce00-3f3e-7358-8a2c-03d2ae3cc925.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/johnston-willis-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18321833032577784974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnston-willis-hospital",
      "poi_latitude": "37.510606",
      "poi_longitude": "-77.5946555",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-483-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2901-71b9-964b-abe7236c675a",
        "storage_key": "property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDx25C21tsYkRjhzR5BE6RP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_68b61239-be9c-4ecf-86f0-2634c116d805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "HCA Healthcare - Capital Division",
      "poi_type": "Major Employers & Offices",
      "poi_address": "901 E Cary St Suite 2100, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-61b2-7548-9681-28d045c358fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-61b2-7548-9681-28d045c358fb",
        "storage_key": "property/6767906449166324/019fce00-61b2-7548-9681-28d045c358fb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://hcacapitaldivision.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2982739229564280893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthcare---capital-division",
      "poi_latitude": "37.5368254",
      "poi_longitude": "-77.437213",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-327-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAzPLrJISsYkRPSDNq4bRZCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c97def45-fc94-4c29-8600-e208a71779f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "VCU Medical Center Main Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1250 E Marshall St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-6267-749c-a65f-660fd7a3630c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-6267-749c-a65f-660fd7a3630c",
        "storage_key": "property/6767906449166324/019fce00-6267-749c-a65f-660fd7a3630c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vcuhealth.org/locations/location-details?practice=10",
      "poi_directions_map_url": "https://maps.google.com/?cid=16171533531014720203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vcu-medical-center-main-hospital",
      "poi_latitude": "37.5404994",
      "poi_longitude": "-77.4304837",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-828-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2901-71b9-964b-abe7236c675a",
        "storage_key": "property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHcj3gSERsYkRy2pz5RDUbOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0a5b1230-9a62-4565-8d94-6a1a3eed224e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "VCU Health Stony Point 9000",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9000 Stony Point Pkwy, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-64a4-76be-a65d-aa06b88e7efe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-64a4-76be-a65d-aa06b88e7efe",
        "storage_key": "property/6767906449166324/019fce00-64a4-76be-a65d-aa06b88e7efe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vcuhealth.org/Locations/Stony-Point-Campus/Stony-Point-9000",
      "poi_directions_map_url": "https://maps.google.com/?cid=16606145862488641077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vcu-health-stony-point-9000",
      "poi_latitude": "37.5532742",
      "poi_longitude": "-77.5656973",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-828-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAZpTmrVssYkRNU71xa3hdOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_19e83f44-8d73-418d-8fd2-e8c95d02aa28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "410 Westhampton Way",
      "poi_type": "Major Employers & Offices",
      "poi_address": "410 Westhampton Way, Richmond, VA 23173, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-6735-72b2-bfec-5dccbb7e4dcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-6735-72b2-bfec-5dccbb7e4dcc",
        "storage_key": "property/6767906449166324/019fce00-6735-72b2-bfec-5dccbb7e4dcc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11539126774048606380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "410-westhampton-way",
      "poi_latitude": "37.5758243",
      "poi_longitude": "-77.5397192",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtXlSJ6IUsYkRrMhdAao2I6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_71374d6d-3d68-440f-a2ec-b70bbc2bbc14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Dominion Energy Virginia",
      "poi_type": "Major Employers & Offices",
      "poi_address": "120 Tredegar St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-6880-733e-87ae-8710f514887c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-6880-733e-87ae-8710f514887c",
        "storage_key": "property/6767906449166324/019fce00-6880-733e-87ae-8710f514887c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dominionenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11041679550737667097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominion-energy-virginia",
      "poi_latitude": "37.533753",
      "poi_longitude": "-77.4537127",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 866-366-4357",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2541-750c-b8d4-cbd6cb442121",
        "storage_key": "property/6767906449166324/019d0268-2541-750c-b8d4-cbd6cb442121.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj2CeDWwRsYkRGdRp0QztO5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_36e5186f-6e1e-4308-a920-95fee7f90fc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Altria Center For Research and Technology",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 E Jackson St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-68f6-753f-ad86-0697890def16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-68f6-753f-ad86-0697890def16",
        "storage_key": "property/6767906449166324/019fce00-68f6-753f-ad86-0697890def16.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.altria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1416499519206913973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "altria-center-for-research-and-technology",
      "poi_latitude": "37.5458709",
      "poi_longitude": "-77.4335486",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-697-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2544-70dc-b6de-323e09cad92e",
        "storage_key": "property/6767906449166324/019d0268-2544-70dc-b6de-323e09cad92e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYZbeAiURsYkRtffWys5qqBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_39971e39-29e1-4ce7-8737-9061a67d984c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Virginia Information Technologies Agency",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7325 Beaufont Springs Dr, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-6c10-74a8-b95e-4a4564d2cbcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-6c10-74a8-b95e-4a4564d2cbcc",
        "storage_key": "property/6767906449166324/019fce00-6c10-74a8-b95e-4a4564d2cbcc.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.vita.virginia.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12465832840537957395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-information-technologies-agency",
      "poi_latitude": "37.5068693",
      "poi_longitude": "-77.5292484",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-510-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2c97-705e-ad12-9947f4c81ea4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2c97-705e-ad12-9947f4c81ea4",
        "storage_key": "property/6767906449166324/019d0268-2c97-705e-ad12-9947f4c81ea4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHYqsm4oGsYkRE-Sp8euI_6w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0f01b9e9-ef8a-4db6-8f79-b540b559c36e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "poi_name": "Henrico Doctors' Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1602 Skipwith Rd, Richmond, VA 23229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-6dbd-74bf-a820-f13a69d62f85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce00-6dbd-74bf-a820-f13a69d62f85",
        "storage_key": "property/6767906449166324/019fce00-6dbd-74bf-a820-f13a69d62f85.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/henrico-doctors-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15700599121967616172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henrico-doctors-hospital",
      "poi_latitude": "37.6040431",
      "poi_longitude": "-77.5400619",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-289-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-2901-71b9-964b-abe7236c675a",
        "storage_key": "property/6767906449166324/019d0268-2901-71b9-964b-abe7236c675a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJhWNnit0UsYkRrJCwUbe749k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_53afbb5a-2362-400f-b523-053809ec9638",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d56a0330-e0c3-409b-95ba-69568635d3ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c623a2de-ff54-413d-b190-fdea21927b7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_23279b8f-dee6-450c-85c2-9c99d6292942",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1e54c3cf-e66e-4914-9c3d-aeccc3783867",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_62de4ce2-5c55-4f69-805a-f19fc426de7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_1497503a0c7d4fa0ccd26e0f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "rating": "5",
      "name": "amy drame",
      "text": "Rented from this place for the past year and had a great experience. No rats bugs or insects through the whole lease. When you have a problem Maintence comes quick. Walls are thin but that depends on your neighbor. The apartment give you everything you need and the neighborhood is safe. I would recommend this spot",
      "date": "2025-10-20",
      "title": "false"
    },
    {
      "id": "ec_aa26994a34b8d60e77efa281",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "rating": "5",
      "name": "Emely Hernandez",
      "text": "My experience with them has been very positive. Berenice Torres guided me through the entire process from start to finish, assisting me every step of the way. I'm thrilled with my new home. Thank you, Leasing Associate.",
      "date": "2025-08-29",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_0189c3b0-7766-4957-aa69-9c10bfa83132",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a157c3-6e8b-75e9-8886-a3d2232b1214.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with white cabinets, black appliances, and a stacked washer and dryer.",
        "public_id": "01a157c3-6e8b-75e9-8886-a3d2232b1214",
        "storage_key": "property/6767906449166324/01a157c3-6e8b-75e9-8886-a3d2232b1214.webp",
        "width": 1280,
        "height": 854
      },
      "virtual_tour_title": "Virtual Tours",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6a754e1cfc62cb691bc6de75"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_60606f52d84e48287cbe958b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "396325",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_287fcb464f0d9f3edfe3f3f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "396327",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8f3b3dd1c80bc49dfcd10751",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "396328",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 1000,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_bf6928d9b93c1296294b5d74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "396331",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ea00b2c7d895fc89a48b4332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "396332",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b11dff923c4bb69af0a398aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "396333",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e1cc8466b9ceaacc3c3eba19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "396334",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9428a7717a62481168b0ae39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "536727",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2301035e08965d699f1a206a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "543051",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ac479f1a8a084a9fe97fad9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "543053",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_48783eb954dff1cfb02a02ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "835103",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3e2993db39bd5fcb5d7adc3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "835107",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cc7ffd702431d3c5b13d6881",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "engrain",
      "external_id": "835109",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1310-67f3-7370-af31-badd1da10892",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-james-river-pointe-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324"
    },
    {
      "lead_collector_id": "019c3043-66b5-723e-aeb6-92d7e3e00768",
      "lead_source": "FACEBOOK_ADS",
      "name": "james-river-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324"
    },
    {
      "lead_collector_id": "019c3043-6725-726e-bd11-f8020b097247",
      "lead_source": "LANDING_PAGE",
      "name": "james-river-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-richmond-va-823",
      "search_query": "pet friendly apartments Richmond VA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Richmond, VA",
      "h2_subtitle": "Discover pet-friendly living at James River Pointe in Richmond, VA. Your four-legged friends are welcome in our vibrant community.",
      "page_copy": "James River Pointe is the premier destination for pet friendly apartments in Richmond, VA. Nestled in the welcoming Westover neighborhood, our community ensures both you and your furry companions have a comfortable and enjoyable living experience. Residents and their pets love our spacious dog park, perfect for playtime and socializing. Choose from our selection of one, two, or three-bedroom apartments that provide plenty of room for all.\n\nOur community is designed with pet lovers in mind. Besides our fantastic amenities like a swimming pool and sundeck, you'll appreciate the welcoming atmosphere fostered by our bilingual team. Make flexibility a priority with our accommodating rent payment options, making James River Pointe an ideal home for you and your pets. Dive into a joyful lifestyle in a place that cherishes pets as much as you do.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Richmond, VA",
      "seo_description": "Find pet friendly apartments in Richmond, VA at James River Pointe. Enjoy luxury amenities including a dog park and more. Discover your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "apartments-with-pool-richmond-city-871",
      "search_query": "apartments with pool in Richmond City",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Richmond City",
      "h2_subtitle": "Explore James River Pointe, where you can enjoy stylish living. Relax by our luxurious pool, a highlight of our Richmond City apartments.",
      "page_copy": "Experience elevated living at James River Pointe, offering premier apartments with a pool in Richmond City. Our sparkling swimming pool, accompanied by a spacious sundeck, provides a perfect retreat for relaxation and enjoyment. Located in the vibrant Westover neighborhood, our community ensures you have a refreshing oasis right at home.\n\nChoose from our stylish one, two, or three-bedroom apartment layouts, all designed with comfort and convenience in mind. In addition to our remarkable pool, residents benefit from amenities like flex rent payments and a bilingual property team ready to assist. Immerse yourself in a welcoming and lively community atmosphere, with the added perk of enjoying sunny days poolside. Make James River Pointe your sanctuary in Richmond City today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Richmond City",
      "seo_description": "Discover apartments with a pool in Richmond City at James River Pointe. Enjoy luxury living with a pool and other top-notch amenities. Join us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "dog-park-apartments-westover-richmond-67",
      "search_query": "dog park apartments Westover Richmond",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Westover, Richmond",
      "h2_subtitle": "Welcome to James River Pointe, Westover's ideal choice for dog-friendly apartments. Enjoy access to our spacious dog park.",
      "page_copy": "James River Pointe offers exceptional dog park apartments in the heart of Westover, Richmond. Our pet-friendly community boasts a spacious dog park, providing the ideal setting for your canine companions to run, play, and socialize. Located in the welcoming Westover neighborhood, you'll find a unique blend of tranquility and convenience.\n\nExplore our stylish one, two, and three-bedroom apartments, each thoughtfully designed to accommodate a pet-friendly lifestyle. Beyond our beautiful dog park, our community offers other enticing amenities like a swimming pool and sundeck, ensuring both you and your pets can relax and enjoy. With a bilingual property team and flexible rent payment options, James River Pointe is a perfect home for you and your furry friends. Embrace a vibrant community atmosphere that prioritizes your pets.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Westover, Richmond",
      "seo_description": "Find ideal dog park apartments in Westover, Richmond at James River Pointe. Enjoy pet-friendly amenities including a spacious dog park and more!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-23225-369",
      "search_query": "air conditioned apartments in 23225",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in 23225",
      "h2_subtitle": "Stay comfortable year-round at James River Pointe, offering air conditioned apartments in the 23225 area. Experience convenient living today.",
      "page_copy": "Stay cool and comfortable at James River Pointe, offering air conditioned apartments in the desirable 23225 ZIP code. Nestled in Richmond's vibrant Westover neighborhood, our community provides a sanctuary of comfort against the Virginia heat. Our one, two, and three-bedroom apartments come equipped with modern air conditioning systems, ensuring a pleasant living environment throughout the year.\n\nIn addition to air conditioning, residents of James River Pointe enjoy a plethora of amenities designed for a luxury lifestyle. Dive into our beautiful swimming pool, spend time at the dog park, or lounge on the sun deck. With a bilingual property team ready to assist and flexible rent payment plans, we make life in 23225 both comfortable and convenient. Discover how relaxing home can be when you choose James River Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in 23225",
      "seo_description": "Experience comfort at James River Pointe's air conditioned apartments in 23225. Enjoy modern amenities and a convenient location today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "apartments-in-unit-washer-dryer-richmond-966",
      "search_query": "apartments with in unit washer and dryer Richmond",
      "category": "Amenity",
      "h1_title": "In-Unit Washer and Dryer Apartments in Richmond",
      "h2_subtitle": "Discover the convenience at James River Pointe, offering apartments with in-unit washer and dryer setups in Richmond. Your laundry day just got easier.",
      "page_copy": "Simplify your life with apartments that feature in-unit washer and dryer facilities at James River Pointe in Richmond. Located in the lively Westover neighborhood, our community combines ease and luxury, ensuring that laundry days are a breeze. Choose from our range of stylish one, two, or three-bedroom layouts, and enjoy a living space that blends practicality with elegant design.\n\nIn addition to the convenience of in-unit laundry, residents can indulge in our wide array of community amenities. From a sparkling swimming pool to a fully-equipped dog park, James River Pointe promotes an active and enjoyable lifestyle. With a bilingual team ready to assist and flexible rent payment options, we offer a resident experience that prioritizes your needs and comfort. Join our community and enjoy all Richmond has to offer, with the conveniences of modern living at James River Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer and Dryer Apartments Richmond",
      "seo_description": "James River Pointe offers Richmond apartments with in-unit washer and dryer. Enjoy modern comforts and amenities in a great location today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-richmond-va-959",
      "search_query": "1 bedroom apartments Richmond VA",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Richmond, VA",
      "h2_subtitle": "Explore the stylish 1 bedroom apartments at James River Pointe in Richmond, VA. Experience comfort and convenience in a vibrant community.",
      "page_copy": "Discover the perfect one-bedroom living space at James River Pointe, located in the heart of Richmond, VA. Our one-bedroom apartments are thoughtfully designed to offer both comfort and functionality, catering to your lifestyle needs in a vibrant community setting. Situated in the welcoming Westover neighborhood, James River Pointe combines tranquility with convenience.\n\nOur residents enjoy a host of impressive amenities, including access to a refreshing swimming pool, a dog park, and a spacious sundeck, enhancing the overall living experience. With flexible rent payment plans and a bilingual property management team dedicated to your satisfaction, James River Pointe offers a seamless blend of modern living and affordability. Make the move to a one-bedroom apartment that truly feels like home in Richmond, VA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Richmond, VA",
      "seo_description": "Find stylish 1 bedroom apartments in Richmond, VA at James River Pointe. Enjoy modern amenities and convenient living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-westover-richmond-111",
      "search_query": "2 bedroom apartments Westover Richmond",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Westover Richmond",
      "h2_subtitle": "Find spacious 2 bedroom apartments at James River Pointe, located in the Westover area of Richmond. Perfect for comfort and style.",
      "page_copy": "Welcome to James River Pointe, where you'll find generously sized 2 bedroom apartments nestled in Richmond's charming Westover neighborhood. Our community provides the perfect blend of urban convenience and suburban tranquility, making it ideal for anyone seeking both comfort and style in their living space.\n\nEach two-bedroom apartment is designed with modern comfort in mind, featuring open layouts and quality finishes. Beyond your apartment, enjoy the relaxing amenities such as a shimmering swimming pool and a lively dog park, catering to both relaxation and recreation. With a bilingual management team and convenient flex rent payments, we ensure a seamless living experience tailored to your needs. Discover the advantages of living at James River Pointe today, where our two-bedroom options offer an unmatched home base in Westover Richmond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Westover Richmond",
      "seo_description": "Explore 2 bedroom apartments in Westover Richmond at James River Pointe. Enjoy modern amenities and ideal location in this vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "3-bedroom-apartments-richmond-city-655",
      "search_query": "3 bedroom apartments in Richmond City",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Richmond City",
      "h2_subtitle": "Discover spacious 3 bedroom apartments at James River Pointe, located in Richmond City. Experience exceptional living in a thriving community.",
      "page_copy": "At James River Pointe, our three-bedroom apartments in Richmond City offer expansive living spaces that cater to families and individuals who need room to stretch and grow. These well-appointed homes boast modern interiors, making them perfect for those seeking both functionality and style in their living environment. Situated in the vibrant Westover neighborhood, our community provides the perfect backdrop for life in Richmond City.\n\nResidents at James River Pointe enjoy access to a variety of upscale amenities, including a refreshing swimming pool, a dedicated dog park for furry friends, and a relaxing sundeck. Our bilingual management team is committed to providing outstanding service, while flexible rent payment options add convenience to your everyday life. Experience the best of Richmond City living in our expansive three-bedroom apartments designed for comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Richmond City",
      "seo_description": "Find expansive 3 bedroom apartments in Richmond City at James River Pointe. Enjoy modern amenities and a great location today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "apartments-near-elizabeth-d-redd-elementary-854",
      "search_query": "apartments near Elizabeth D Redd Elem School Richmond",
      "category": "School",
      "h1_title": "Apartments Near Elizabeth D Redd Elem School",
      "h2_subtitle": "Discover ideal apartments near Elizabeth D Redd Elementary School at James River Pointe. Enjoy convenience in a family-friendly community in Richmond.",
      "page_copy": "James River Pointe offers an exceptional living experience with apartments conveniently located near Elizabeth D Redd Elementary School in Richmond. Our community caters to families seeking quality education options within a close-knit and welcoming environment. Located in Richmond's vibrant Westover neighborhood, these apartments provide an ideal setting for both comfort and convenience.\n\nResidents enjoy various community features like a refreshing swimming pool, a lively dog park, and a spacious sundeck, perfect for leisure and recreation. Our bilingual management team focuses on enhancing resident satisfaction, and with flexible rent payment options, we ensure an accommodating living experience. Choose James River Pointe if you're looking for proximity to Elizabeth D Redd Elementary School and a supportive community environment in Richmond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Elizabeth D Redd Elem School",
      "seo_description": "Find family-friendly apartments near Elizabeth D Redd Elementary in Richmond at James River Pointe. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "apartments-near-lucille-m-brown-middle-school-453",
      "search_query": "apartments close to Lucille M. Brown Middle School Westover",
      "category": "School",
      "h1_title": "Apartments Close to Lucille M. Brown Middle",
      "h2_subtitle": "Find great apartments near Lucille M. Brown Middle School in Westover at James River Pointe. Enjoy a community-focused living experience.",
      "page_copy": "James River Pointe offers inviting apartments conveniently close to Lucille M. Brown Middle School, perfect for families seeking educational accessibility in Richmond's Westover area. Our community provides a supportive environment where convenience and comfort merge effortlessly, making it an ideal choice for families in the region.\n\nResidents benefit from exceptional amenities, including a sparkling swimming pool, a fun dog park, and a relaxing sundeck. Additionally, our bilingual team is dedicated to providing excellent service, and flexible rent payment options are available to suit diverse needs. Choose James River Pointe if you're looking for a vibrant community atmosphere near Lucille M. Brown Middle School, where you can enjoy both a central location and a range of modern comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Lucille M. Brown Middle",
      "seo_description": "Discover great living at James River Pointe, with apartments near Lucille M. Brown Middle School. Ideal location in Westover with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "luxury-apartments-near-huguenot-high-school-111",
      "search_query": "luxury apartments near Huguenot High School Richmond",
      "category": "School",
      "h1_title": "Luxury Apartments Near Huguenot High School",
      "h2_subtitle": "Explore luxury living near Huguenot High School in Richmond at James River Pointe. Experience upscale amenities and a welcoming community.",
      "page_copy": "Discover the charm of James River Pointe, offering luxury apartments near Huguenot High School in Richmond. These upscale homes provide a perfect blend of modern design and sophisticated amenities, catering to families and individuals who value convenience and elegance. Nestled in the dynamic Westover neighborhood, our community is ideal for those seeking proximity to quality education and urban conveniences.\n\nAt James River Pointe, residents enjoy an array of exclusive features, including a refreshing swimming pool, dog-friendly park, and spacious sundeck, all designed to enhance your lifestyle. Our bilingual property team dedicates itself to superior service, and flexible rent payment options ensure ease and comfort. For those desiring luxury living near Huguenot High School, James River Pointe offers the ideal setting to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near Huguenot High School",
      "seo_description": "Find luxury apartments at James River Pointe, close to Huguenot High School in Richmond. Enjoy upscale amenities and a prime location in Westover.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "family-friendly-apartments-southampton-elementary-264",
      "search_query": "family-friendly apartments near Southampton Elementary School 23225",
      "category": "School",
      "h1_title": "Family-Friendly Apartments Near Southampton Elementary",
      "h2_subtitle": "Discover family-friendly apartments near Southampton Elementary School at James River Pointe. Ideal for families seeking comfort in the 23225 area.",
      "page_copy": "Located in the heart of Richmond's 23225 area, James River Pointe offers family-friendly apartments just minutes from Southampton Elementary School. Our community is designed with families in mind, providing easy access to excellent educational opportunities and a supportive neighborhood environment.\n\nJames River Pointe boasts an array of amenities that cater to every family member, including a sparkling swimming pool for weekend fun, a convenient dog park, and a relaxing sundeck. Our bilingual team ensures a welcoming atmosphere, with flexible rent options that adapt to each family's needs. Experience the perfect blend of convenience and community living at James River Pointe, the ideal choice for families seeking proximity to Southampton Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments Near Southampton",
      "seo_description": "Discover family-friendly living at James River Pointe, close to Southampton Elementary School. Ideal for families in Richmond's 23225 with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "apartments-near-elijah-house-academy-va-465",
      "search_query": "apartments near Elijah House Academy VA",
      "category": "School",
      "h1_title": "Apartments Near Elijah House Academy, VA",
      "h2_subtitle": "Explore convenient living near Elijah House Academy in Richmond at James River Pointe. Enjoy stylish apartments with top-notch amenities.",
      "page_copy": "James River Pointe presents ideal apartments near Elijah House Academy, VA, offering convenience and modern living in the vibrant city of Richmond. Nestled in the Westover neighborhood, our community is well-suited for families and individuals who prioritize educational access alongside a comfortable lifestyle.\n\nAt James River Pointe, residents benefit from luxurious amenities such as a refreshing swimming pool, an enjoyable dog park, and a relaxing sundeck, making it a perfect place to unwind. Our bilingual property team is dedicated to catering to diverse needs, with flexible rent payment options enhancing the ease of living here. If you're looking for a home near Elijah House Academy, James River Pointe provides both proximity and all the comforts you desire.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Elijah House Academy, VA",
      "seo_description": "Find ideal apartments at James River Pointe near Elijah House Academy, VA. Enjoy a convenient Richmond location with stylish living and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "convenient-apartments-good-shepherd-episcopal-school-784",
      "search_query": "convenient apartments close to Good Shepherd Episcopal School Richmond City",
      "category": "School",
      "h1_title": "Convenient Apartments Near Good Shepherd School",
      "h2_subtitle": "Discover convenient apartments close to Good Shepherd Episcopal School in Richmond City at James River Pointe. Enjoy modern living with exceptional amenities.",
      "page_copy": "Located in Richmond City, James River Pointe offers convenient apartments near Good Shepherd Episcopal School, perfect for families and individuals looking for proximity to quality education and urban amenities. Our property combines the best of community living and accessibility, making it easy to balance school, work, and leisure.\n\nResidents of James River Pointe relish a variety of upscale features, including a community swimming pool, spacious sundeck, and a welcoming dog park, perfect for engaging and relaxing. Our bilingual team is always ready to assist, providing a friendly environment with flexible rent payment options. Choose James River Pointe for convenient living close to Good Shepherd Episcopal School, where comfort meets accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments Near Good Shepherd School",
      "seo_description": "Enjoy convenient living at James River Pointe, close to Good Shepherd Episcopal School in Richmond City. Experience modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "apartments-near-richmond-waldorf-school-westover-76",
      "search_query": "apartments near Richmond Waldorf School neighborhood Westover",
      "category": "School",
      "h1_title": "Apartments Near Richmond Waldorf School, Westover",
      "h2_subtitle": "Discover apartments near Richmond Waldorf School in the Westover neighborhood. Enjoy a vibrant community and modern amenities at James River Pointe.",
      "page_copy": "Situated in the charming neighborhood of Westover, James River Pointe provides ideal living options near Richmond Waldorf School. Perfect for families who value both education and convenience, our community offers stylish one-, two-, and three-bedroom apartments designed for comfortable living.\n\nResidents at James River Pointe enjoy access to a variety of upscale amenities, such as a sparkling swimming pool, engaging dog park, and spacious sundeck. Our dedicated bilingual team ensures a welcoming atmosphere, providing flexible rent payment options to suit diverse needs. If you're seeking a balance of modern living and access to Richmond Waldorf School, James River Pointe is the perfect choice in the Westover neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Richmond Waldorf School, Westover",
      "seo_description": "Live near Richmond Waldorf School in Westover. James River Pointe offers modern apartments with great amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "apartments-near-chippenham-hospital-richmond-547",
      "search_query": "apartments near Chippenham Hospital Richmond",
      "category": "Hospital",
      "h1_title": "Apartments Near Chippenham Hospital, Richmond",
      "h2_subtitle": "Explore convenient apartments near Chippenham Hospital in Richmond. James River Pointe offers modern amenities and a prime location for healthcare professionals.",
      "page_copy": "Located a short distance from Chippenham Hospital, James River Pointe is ideal for those seeking convenient living in Richmond. Our community provides quick access to healthcare facilities while offering a tranquil environment featuring spacious one-, two-, and three-bedroom apartments.\n\nEnjoy a range of amenities including a sparkling swimming pool, a welcoming dog park, and a relaxing sundeck. Our bilingual team ensures a warm and supportive community atmosphere, with flexible rent payment options catering to diverse needs. Whether you're a healthcare professional or someone who values proximity to medical services, James River Pointe is your prime choice near Chippenham Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Chippenham Hospital, Richmond",
      "seo_description": "Live close to Chippenham Hospital in Richmond at James River Pointe. Experience convenient living with modern amenities and accessible healthcare.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "apartments-close-to-johnston-willis-hospital-westover-789",
      "search_query": "apartments close to Johnston-Willis Hospital Westover",
      "category": "Hospital",
      "h1_title": "Apartments Close to Johnston-Willis Hospital",
      "h2_subtitle": "Find charming apartments close to Johnston-Willis Hospital in Westover. Enjoy the blend of comfort and accessibility at James River Pointe.",
      "page_copy": "James River Pointe offers convenient living with apartments close to Johnston-Willis Hospital in the Westover area. We provide a perfect location for medical professionals and those who prioritize proximity to healthcare facilities, all while enjoying the neighborhood's unique charm.\n\nOur community features a range of stylish one-, two-, and three-bedroom apartments coupled with premium amenities like a swimming pool, dog park, and sundeck. The supportive, bilingual team at James River Pointe is dedicated to creating a welcoming atmosphere with flexible rent options. Choose James River Pointe and discover the perfect blend of convenience and comfort near Johnston-Willis Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Johnston-Willis Hospital",
      "seo_description": "Discover James River Pointe's convenient living near Johnston-Willis Hospital in Westover. Enjoy modern amenities and easy healthcare access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "apartments-near-james-river-park-pony-pasture-19",
      "search_query": "apartments near James River Park Pony Pasture",
      "category": "Park",
      "h1_title": "Apartments Near James River Park Pony Pasture",
      "h2_subtitle": "Explore apartments near James River Park's Pony Pasture. James River Pointe offers a convenient location with premium amenities for nature enthusiasts.",
      "page_copy": "Experience the best of outdoor living with James River Pointe, offering apartments near the scenic James River Park's Pony Pasture. Located in Richmond, our community provides easy access to one of the area's most beloved natural attractions, ideal for those who enjoy outdoor activities like kayaking, hiking, and picnicking.\n\nResidents can unwind at our stylish apartments with modern comforts such as a vibrant dog park, a refreshing swimming pool, and a spacious sundeck. Our bilingual team is dedicated to ensuring an accommodating atmosphere, providing flexible rent payment options tailored to fit your lifestyle. Enjoy the perfect combination of urban convenience and nature's tranquility at James River Pointe, located close to Pony Pasture.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near James River Park Pony Pasture",
      "seo_description": "Live near the beautiful James River Park Pony Pasture at James River Pointe. Enjoy modern amenities and easy access to nature in Richmond.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "richmond-apartments-close-to-reedy-creek-trailhead-929",
      "search_query": "Richmond apartments close to Reedy Creek Trailhead",
      "category": "Park",
      "h1_title": "Richmond Apartments Close to Reedy Creek Trailhead",
      "h2_subtitle": "Discover Richmond apartments close to Reedy Creek Trailhead at James River Pointe. Enjoy nature access with modern living amenities.",
      "page_copy": "Explore the blend of nature and city living at James River Pointe, offering Richmond apartments close to the Reedy Creek Trailhead. This prime location is perfect for those who love to explore the great outdoors, with trails that provide scenic views and recreational opportunities.\n\nChoose from our selection of one-, two-, and three-bedroom apartments that feature luxurious amenities like a sparkling swimming pool, a lively dog park, and a sun-drenched sundeck. The bilingual team at James River Pointe is committed to providing a welcoming environment with flexible rent payment options, making it easy for you to feel at home. Benefit from the ideal location and a thriving community near Reedy Creek Trailhead.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Richmond Apartments Near Reedy Creek Trailhead",
      "seo_description": "Find your home at James River Pointe near Reedy Creek Trailhead. Enjoy modern living amenities and easy access to Richmond's natural trails.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166324",
      "source": "custom",
      "page_item_url": "forest-hill-park-nearby-westover-apartments-210",
      "search_query": "Forest Hill Park nearby Westover apartments",
      "category": "Park",
      "h1_title": "Forest Hill Park Nearby Westover Apartments",
      "h2_subtitle": "Explore Westover apartments near Forest Hill Park at James River Pointe. Experience the charm of Richmond with beautiful park views.",
      "page_copy": "Nestled in the vibrant Westover area, James River Pointe offers stunning apartments close to Forest Hill Park. This location is ideal for those who appreciate the beauty of nature combined with the convenience of urban living. Whether you love weekend picnics, jogging, or simply enjoying the serene park atmosphere, our community provides easy access to these experiences.\n\nOur selection of one-, two-, and three-bedroom apartments feature exceptional amenities such as a relaxing swimming pool, scenic sundeck, and a dedicated dog park. The bilingual team at James River Pointe ensures a warm and welcoming atmosphere with flexible rent options. Enjoy unparalleled comfort and the allure of Forest Hill Park at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdff-c8d7-70ac-b2a9-812fd866109d",
        "storage_key": "property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Westover Apartments Near Forest Hill Park",
      "seo_description": "Discover James River Pointe's Westover apartments near Forest Hill Park. Enjoy modern amenities and easy access to Richmond's beautiful park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5061"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976254268"
    },
    {
      "ID": "custom_fee_guide",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4993359"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MRN56658"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://jamesriverpointe.fatwin.com/api/websites/resources/1?x=L2dvakl2OXphQXlTYkl0NmM3Q2RWOUdDaGxDOC9YRE5ZaFZVaHRtMGlFamVwcTdSNzRSUXFBcklOMTFoNzEvVkFkQm5OUUV3TmNjQXIzVy96aDJ5S3c9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dqw971x0vo9"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "954a3f52-43e6-11ef-8614-2b8d4458d933"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a3f52-43e6-11ef-8614-2b8d4458d933/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a3f52-43e6-11ef-8614-2b8d4458d933/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkhWaGw1RW1XYUtPRnYxSEhsa2U4ZGc9PSIsInZhbHVlIjoidEFvWUgrK1g2ejhpaXhKU0YwQ0V4Zz09IiwibWFjIjoiYzNmNDc4MWU3ZmM1YWM2ZTI3Yzg0MDA3Y2Q3YWEzNTBiNzhiMTA3NmRiNDM2NDFlMjkwZDk1Njg2NGRiMTkyMCJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5061",
  "custom_repli_id": "9976254268",
  "custom_fee_guide": "true",
  "custom_realpage_id": "4993359",
  "custom_google_gtm_id": "GTM-MRN56658",
  "custom_perq_script_url": "https://jamesriverpointe.fatwin.com/api/websites/resources/1?x=L2dvakl2OXphQXlTYkl0NmM3Q2RWOUdDaGxDOC9YRE5ZaFZVaHRtMGlFamVwcTdSNzRSUXFBcklOMTFoNzEvVkFkQm5OUUV3TmNjQXIzVy96aDJ5S3c9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/dqw971x0vo9",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "954a3f52-43e6-11ef-8614-2b8d4458d933",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a3f52-43e6-11ef-8614-2b8d4458d933/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a3f52-43e6-11ef-8614-2b8d4458d933/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkhWaGw1RW1XYUtPRnYxSEhsa2U4ZGc9PSIsInZhbHVlIjoidEFvWUgrK1g2ejhpaXhKU0YwQ0V4Zz09IiwibWFjIjoiYzNmNDc4MWU3ZmM1YWM2ZTI3Yzg0MDA3Y2Q3YWEzNTBiNzhiMTA3NmRiNDM2NDFlMjkwZDk1Njg2NGRiMTkyMCJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "6ae9604a-78f3-4bb8-bd33-a3f6eda5ad3a",
  "custom_audioeye_site_hash": "a4d860e9b6265b48bb10612433e8ae5e"
};

export const generatedAt = '2026-10-22T20:06:26.642Z';
